export const emojisDefault = [
  { emoji: '😀', category: 'Peoples', tags: ['grinning'] },
  { emoji: '😃', category: 'Peoples', tags: ['smiley'] },
  { emoji: '😄', category: 'Peoples', tags: ['smile'] },
  { emoji: '😁', category: 'Peoples', tags: ['grin'] },
  { emoji: '😆', category: 'Peoples', tags: ['laughing', 'satisfied'] },
  { emoji: '😅', category: 'Peoples', tags: ['sweat_smile'] },
  { emoji: '😂', category: 'Peoples', tags: ['joy'] },
  { emoji: '🤣', category: 'Peoples', tags: ['rofl'] },
  { emoji: '😌', category: 'Peoples', tags: ['relaxed'] },
  { emoji: '😊', category: 'Peoples', tags: ['blush'] },
  { emoji: '😇', category: 'Peoples', tags: ['innocent'] },
  { emoji: '🙂', category: 'Peoples', tags: ['slightly_smiling_face'] },
  { emoji: '🙃', category: 'Peoples', tags: ['upside_down_face'] },
  { emoji: '😉', category: 'Peoples', tags: ['wink'] },
  { emoji: '😌', category: 'Peoples', tags: ['relieved'] },
  { emoji: '😍', category: 'Peoples', tags: ['heart_eyes'] },
  { emoji: '😘', category: 'Peoples', tags: ['kissing_heart'] },
  { emoji: '😗', category: 'Peoples', tags: ['kissing'] },
  { emoji: '😙', category: 'Peoples', tags: ['kissing_smiling_eyes'] },
  { emoji: '😚', category: 'Peoples', tags: ['kissing_closed_eyes'] },
  { emoji: '😋', category: 'Peoples', tags: ['yum'] },
  { emoji: '😜', category: 'Peoples', tags: ['stuck_out_tongue_winking_eye'] },
  { emoji: '😝', category: 'Peoples', tags: ['stuck_out_tongue_closed_eyes'] },
  { emoji: '😛', category: 'Peoples', tags: ['stuck_out_tongue'] },
  { emoji: '🤑', category: 'Peoples', tags: ['money_mouth_face'] },
  { emoji: '🤗', category: 'Peoples', tags: ['hugs'] },
  { emoji: '🤓', category: 'Peoples', tags: ['nerd_face'] },
  { emoji: '😎', category: 'Peoples', tags: ['sunglasses'] },
  { emoji: '🤡', category: 'Peoples', tags: ['clown_face'] },
  { emoji: '🤠', category: 'Peoples', tags: ['cowboy_hat_face'] },
  { emoji: '😏', category: 'Peoples', tags: ['smirk'] },
  { emoji: '😒', category: 'Peoples', tags: ['unamused'] },
  { emoji: '😞', category: 'Peoples', tags: ['disappointed'] },
  { emoji: '😔', category: 'Peoples', tags: ['pensive'] },
  { emoji: '😟', category: 'Peoples', tags: ['worried'] },
  { emoji: '😕', category: 'Peoples', tags: ['confused'] },
  { emoji: '🙁', category: 'Peoples', tags: ['slightly_frowning_face'] },
  { emoji: '☹️', category: 'Peoples', tags: ['frowning_face'] },
  { emoji: '😣', category: 'Peoples', tags: ['persevere'] },
  { emoji: '😖', category: 'Peoples', tags: ['confounded'] },
  { emoji: '😫', category: 'Peoples', tags: ['tired_face'] },
  { emoji: '😩', category: 'Peoples', tags: ['weary'] },
  { emoji: '😤', category: 'Peoples', tags: ['triumph'] },
  { emoji: '😠', category: 'Peoples', tags: ['angry'] },
  { emoji: '😡', category: 'Peoples', tags: ['rage', 'pout'] },
  { emoji: '😶', category: 'Peoples', tags: ['no_mouth'] },
  { emoji: '😐', category: 'Peoples', tags: ['neutral_face'] },
  { emoji: '😑', category: 'Peoples', tags: ['expressionless'] },
  { emoji: '😯', category: 'Peoples', tags: ['hushed'] },
  { emoji: '😦', category: 'Peoples', tags: ['frowning'] },
  { emoji: '😧', category: 'Peoples', tags: ['anguished'] },
  { emoji: '😮', category: 'Peoples', tags: ['open_mouth'] },
  { emoji: '😲', category: 'Peoples', tags: ['astonished'] },
  { emoji: '😵', category: 'Peoples', tags: ['dizzy_face'] },
  { emoji: '😳', category: 'Peoples', tags: ['flushed'] },
  { emoji: '😱', category: 'Peoples', tags: ['scream'] },
  { emoji: '😨', category: 'Peoples', tags: ['fearful'] },
  { emoji: '😰', category: 'Peoples', tags: ['cold_sweat'] },
  { emoji: '😢', category: 'Peoples', tags: ['cry'] },
  { emoji: '😥', category: 'Peoples', tags: ['disappointed_relieved'] },
  { emoji: '🤤', category: 'Peoples', tags: ['drooling_face'] },
  { emoji: '😭', category: 'Peoples', tags: ['sob'] },
  { emoji: '😓', category: 'Peoples', tags: ['sweat'] },
  { emoji: '😪', category: 'Peoples', tags: ['sleepy'] },
  { emoji: '😴', category: 'Peoples', tags: ['sleeping'] },
  { emoji: '🙄', category: 'Peoples', tags: ['roll_eyes'] },
  { emoji: '🤔', category: 'Peoples', tags: ['thinking'] },
  { emoji: '🤥', category: 'Peoples', tags: ['lying_face'] },
  { emoji: '😬', category: 'Peoples', tags: ['grimacing'] },
  { emoji: '🤐', category: 'Peoples', tags: ['zipper_mouth_face'] },
  { emoji: '🤢', category: 'Peoples', tags: ['nauseated_face'] },
  { emoji: '🤧', category: 'Peoples', tags: ['sneezing_face'] },
  { emoji: '😷', category: 'Peoples', tags: ['mask'] },
  { emoji: '🤒', category: 'Peoples', tags: ['face_with_thermometer'] },
  { emoji: '🤕', category: 'Peoples', tags: ['face_with_head_bandage'] },
  { emoji: '😈', category: 'Peoples', tags: ['smiling_imp'] },
  { emoji: '👿', category: 'Peoples', tags: ['imp'] },
  { emoji: '👹', category: 'Peoples', tags: ['japanese_ogre'] },
  { emoji: '👺', category: 'Peoples', tags: ['japanese_goblin'] },
  { emoji: '💩', category: 'Peoples', tags: ['hankey', 'poop', 'shit'] },
  { emoji: '👻', category: 'Peoples', tags: ['ghost'] },
  { emoji: '💀', category: 'Peoples', tags: ['skull'] },
  { emoji: '☠️', category: 'Peoples', tags: ['skull_and_crossbones'] },
  { emoji: '👽', category: 'Peoples', tags: ['alien'] },
  { emoji: '👾', category: 'Peoples', tags: ['space_invader'] },
  { emoji: '🤖', category: 'Peoples', tags: ['robot'] },
  { emoji: '🎃', category: 'Peoples', tags: ['jack_o_lantern'] },
  { emoji: '😺', category: 'Peoples', tags: ['smiley_cat'] },
  { emoji: '😸', category: 'Peoples', tags: ['smile_cat'] },
  { emoji: '😹', category: 'Peoples', tags: ['joy_cat'] },
  { emoji: '😻', category: 'Peoples', tags: ['heart_eyes_cat'] },
  { emoji: '😼', category: 'Peoples', tags: ['smirk_cat'] },
  { emoji: '😽', category: 'Peoples', tags: ['kissing_cat'] },
  { emoji: '🙀', category: 'Peoples', tags: ['scream_cat'] },
  { emoji: '😿', category: 'Peoples', tags: ['crying_cat_face'] },
  { emoji: '😾', category: 'Peoples', tags: ['pouting_cat'] },
  { emoji: '👐', category: 'Peoples', tags: ['open_hands'] },
  { emoji: '🙌', category: 'Peoples', tags: ['raised_hands'] },
  { emoji: '👏', category: 'Peoples', tags: ['clap'] },
  { emoji: '🙏', category: 'Peoples', tags: ['pray'] },
  { emoji: '🤝', category: 'Peoples', tags: ['handshake'] },
  { emoji: '👍', category: 'Peoples', tags: ['+1', 'thumbsup'] },
  { emoji: '👎', category: 'Peoples', tags: ['-1', 'thumbsdown'] },
  {
    emoji: '👊',
    category: 'Peoples',
    tags: ['fist_oncoming', 'facepunch', 'punch'],
  },
  { emoji: '✊', category: 'Peoples', tags: ['fist_raised', 'fist'] },
  { emoji: '🤛', category: 'Peoples', tags: ['fist_left'] },
  { emoji: '🤜', category: 'Peoples', tags: ['fist_right'] },
  { emoji: '🤞', category: 'Peoples', tags: ['crossed_fingers'] },
  { emoji: '✌️', category: 'Peoples', tags: ['v'] },
  { emoji: '🤘', category: 'Peoples', tags: ['metal'] },
  { emoji: '👌', category: 'Peoples', tags: ['ok_hand'] },
  { emoji: '👈', category: 'Peoples', tags: ['point_left'] },
  { emoji: '👉', category: 'Peoples', tags: ['point_right'] },
  { emoji: '👆', category: 'Peoples', tags: ['point_up_2'] },
  { emoji: '👇', category: 'Peoples', tags: ['point_down'] },
  { emoji: '☝️', category: 'Peoples', tags: ['point_up'] },
  { emoji: '✋', category: 'Peoples', tags: ['hand', 'raised_hand'] },
  { emoji: '🤚', category: 'Peoples', tags: ['raised_back_of_hand'] },
  {
    emoji: '🖐',
    category: 'Peoples',
    tags: ['raised_hand_with_fingers_splayed'],
  },
  { emoji: '🖖', category: 'Peoples', tags: ['vulcan_salute'] },
  { emoji: '👋', category: 'Peoples', tags: ['wave'] },
  { emoji: '🤙', category: 'Peoples', tags: ['call_me_hand'] },
  { emoji: '💪', category: 'Peoples', tags: ['muscle'] },
  { emoji: '🖕', category: 'Peoples', tags: ['middle_finger', 'fu'] },
  { emoji: '✍️', category: 'Peoples', tags: ['writing_hand'] },
  { emoji: '🤳', category: 'Peoples', tags: ['selfie'] },
  { emoji: '💅', category: 'Peoples', tags: ['nail_care'] },
  { emoji: '💍', category: 'Peoples', tags: ['ring'] },
  { emoji: '💄', category: 'Peoples', tags: ['lipstick'] },
  { emoji: '💋', category: 'Peoples', tags: ['kiss'] },
  { emoji: '👄', category: 'Peoples', tags: ['lips'] },
  { emoji: '👅', category: 'Peoples', tags: ['tongue'] },
  { emoji: '👂', category: 'Peoples', tags: ['ear'] },
  { emoji: '👃', category: 'Peoples', tags: ['nose'] },
  { emoji: '👣', category: 'Peoples', tags: ['footprints'] },
  { emoji: '👁', category: 'Peoples', tags: ['eye'] },
  { emoji: '👀', category: 'Peoples', tags: ['eyes'] },
  { emoji: '🗣', category: 'Peoples', tags: ['speaking_head'] },
  { emoji: '👤', category: 'Peoples', tags: ['bust_in_silhouette'] },
  { emoji: '👥', category: 'Peoples', tags: ['busts_in_silhouette'] },
  { emoji: '👶', category: 'Peoples', tags: ['baby'] },
  { emoji: '👦', category: 'Peoples', tags: ['boy'] },
  { emoji: '👧', category: 'Peoples', tags: ['girl'] },
  { emoji: '👨', category: 'Peoples', tags: ['man'] },
  { emoji: '👩', category: 'Peoples', tags: ['woman'] },
  { emoji: '👱‍♀', category: 'Peoples', tags: ['blonde_woman'] },
  {
    emoji: '👱',
    category: 'Peoples',
    tags: ['blonde_man', 'person_with_blond_hair'],
  },
  { emoji: '👴', category: 'Peoples', tags: ['older_man'] },
  { emoji: '👵', category: 'Peoples', tags: ['older_woman'] },
  { emoji: '👲', category: 'Peoples', tags: ['man_with_gua_pi_mao'] },
  { emoji: '👳‍♀', category: 'Peoples', tags: ['woman_with_turban'] },
  { emoji: '👳', category: 'Peoples', tags: ['man_with_turban'] },
  { emoji: '👮‍♀', category: 'Peoples', tags: ['policewoman'] },
  { emoji: '👮', category: 'Peoples', tags: ['policeman', 'cop'] },
  { emoji: '👷‍♀', category: 'Peoples', tags: ['construction_worker_woman'] },
  {
    emoji: '👷',
    category: 'Peoples',
    tags: ['construction_worker_man', 'construction_worker'],
  },
  { emoji: '💂‍♀', category: 'Peoples', tags: ['guardswoman'] },
  { emoji: '💂', category: 'Peoples', tags: ['guardsman'] },
  { emoji: '👩‍⚕', category: 'Peoples', tags: ['woman_health_worker'] },
  { emoji: '👨‍⚕', category: 'Peoples', tags: ['man_health_worker'] },
  { emoji: '👩‍🌾', category: 'Peoples', tags: ['woman_farmer'] },
  { emoji: '👨‍🌾', category: 'Peoples', tags: ['man_farmer'] },
  { emoji: '👩‍🍳', category: 'Peoples', tags: ['woman_cook'] },
  { emoji: '👨‍🍳', category: 'Peoples', tags: ['man_cook'] },
  { emoji: '👩‍🎓', category: 'Peoples', tags: ['woman_student'] },
  { emoji: '👨‍🎓', category: 'Peoples', tags: ['man_student'] },
  { emoji: '👩‍🎤', category: 'Peoples', tags: ['woman_singer'] },
  { emoji: '👨‍🎤', category: 'Peoples', tags: ['man_singer'] },
  { emoji: '👩‍🏫', category: 'Peoples', tags: ['woman_teacher'] },
  { emoji: '👨‍🏫', category: 'Peoples', tags: ['man_teacher'] },
  { emoji: '👩‍🏭', category: 'Peoples', tags: ['woman_factory_worker'] },
  { emoji: '👨‍🏭', category: 'Peoples', tags: ['man_factory_worker'] },
  { emoji: '👩‍💻', category: 'Peoples', tags: ['woman_technologist'] },
  { emoji: '👨‍💻', category: 'Peoples', tags: ['man_technologist'] },
  { emoji: '👩‍💼', category: 'Peoples', tags: ['woman_office_worker'] },
  { emoji: '👨‍💼', category: 'Peoples', tags: ['man_office_worker'] },
  { emoji: '👩‍🔧', category: 'Peoples', tags: ['woman_mechanic'] },
  { emoji: '👨‍🔧', category: 'Peoples', tags: ['man_mechanic'] },
  { emoji: '👩‍🔬', category: 'Peoples', tags: ['woman_scientist'] },
  { emoji: '👨‍🔬', category: 'Peoples', tags: ['man_scientist'] },
  { emoji: '👩‍🎨', category: 'Peoples', tags: ['woman_artist'] },
  { emoji: '👨‍🎨', category: 'Peoples', tags: ['man_artist'] },
  { emoji: '👩‍🚒', category: 'Peoples', tags: ['woman_firefighter'] },
  { emoji: '👨‍🚒', category: 'Peoples', tags: ['man_firefighter'] },
  { emoji: '👩‍🚀', category: 'Peoples', tags: ['woman_astronaut'] },
  { emoji: '👨‍🚀', category: 'Peoples', tags: ['man_astronaut'] },
  { emoji: '🤶', category: 'Peoples', tags: ['mrs_claus'] },
  { emoji: '🎅', category: 'Peoples', tags: ['santa'] },
  { emoji: '👸', category: 'Peoples', tags: ['princess'] },
  { emoji: '🤴', category: 'Peoples', tags: ['prince'] },
  { emoji: '👰', category: 'Peoples', tags: ['bride_with_veil'] },
  { emoji: '🤵', category: 'Peoples', tags: ['man_in_tuxedo'] },
  { emoji: '👼', category: 'Peoples', tags: ['angel'] },
  { emoji: '🤰', category: 'Peoples', tags: ['pregnant_woman'] },
  { emoji: '🙇‍♀', category: 'Peoples', tags: ['bowing_woman'] },
  { emoji: '🙇', category: 'Peoples', tags: ['bowing_man', 'bow'] },
  {
    emoji: '💁',
    category: 'Peoples',
    tags: ['tipping_hand_woman', 'information_desk_person', 'sassy_woman'],
  },
  {
    emoji: '💁‍♂',
    category: 'Peoples',
    tags: ['tipping_hand_man', 'sassy_man'],
  },
  {
    emoji: '🙅',
    category: 'Peoples',
    tags: ['no_good_woman', 'no_good', 'ng_woman'],
  },
  { emoji: '🙅‍♂', category: 'Peoples', tags: ['no_good_man', 'ng_man'] },
  { emoji: '🙆', category: 'Peoples', tags: ['ok_woman'] },
  { emoji: '🙆‍♂', category: 'Peoples', tags: ['ok_man'] },
  {
    emoji: '🙋',
    category: 'Peoples',
    tags: ['raising_hand_woman', 'raising_hand'],
  },
  { emoji: '🙋‍♂', category: 'Peoples', tags: ['raising_hand_man'] },
  { emoji: '🤦‍♀', category: 'Peoples', tags: ['woman_facepalming'] },
  { emoji: '🤦‍♂', category: 'Peoples', tags: ['man_facepalming'] },
  { emoji: '🤷‍♀', category: 'Peoples', tags: ['woman_shrugging'] },
  { emoji: '🤷‍♂', category: 'Peoples', tags: ['man_shrugging'] },
  {
    emoji: '🙎',
    category: 'Peoples',
    tags: ['pouting_woman', 'person_with_pouting_face'],
  },
  { emoji: '🙎‍♂', category: 'Peoples', tags: ['pouting_man'] },
  {
    emoji: '🙍',
    category: 'Peoples',
    tags: ['frowning_woman', 'person_frowning'],
  },
  { emoji: '🙍‍♂', category: 'Peoples', tags: ['frowning_man'] },
  { emoji: '💇', category: 'Peoples', tags: ['haircut_woman', 'haircut'] },
  { emoji: '💇‍♂', category: 'Peoples', tags: ['haircut_man'] },
  { emoji: '💆', category: 'Peoples', tags: ['massage_woman', 'massage'] },
  { emoji: '💆‍♂', category: 'Peoples', tags: ['massage_man'] },
  { emoji: '🕴', category: 'Peoples', tags: ['business_suit_levitating'] },
  { emoji: '💃', category: 'Peoples', tags: ['dancer'] },
  { emoji: '🕺', category: 'Peoples', tags: ['man_dancing'] },
  { emoji: '👯', category: 'Peoples', tags: ['dancing_women', 'dancers'] },
  { emoji: '👯‍♂', category: 'Peoples', tags: ['dancing_men'] },
  { emoji: '🚶‍♀', category: 'Peoples', tags: ['walking_woman'] },
  { emoji: '🚶', category: 'Peoples', tags: ['walking_man', 'walking'] },
  { emoji: '🏃‍♀', category: 'Peoples', tags: ['running_woman'] },
  {
    emoji: '🏃',
    category: 'Peoples',
    tags: ['running_man', 'runner', 'running'],
  },
  { emoji: '👫', category: 'Peoples', tags: ['couple'] },
  { emoji: '👭', category: 'Peoples', tags: ['two_women_holding_hands'] },
  { emoji: '👬', category: 'Peoples', tags: ['two_men_holding_hands'] },
  {
    emoji: '💑',
    category: 'Peoples',
    tags: ['couple_with_heart_woman_man', 'couple_with_heart'],
  },
  { emoji: '👩‍❤️‍👩', category: 'Peoples', tags: ['couple_with_heart_woman_woman'] },
  { emoji: '👨‍❤️‍👨', category: 'Peoples', tags: ['couple_with_heart_man_man'] },
  { emoji: '💏', category: 'Peoples', tags: ['couplekiss_man_woman'] },
  { emoji: '👩‍❤️‍💋‍👩', category: 'Peoples', tags: ['couplekiss_woman_woman'] },
  { emoji: '👨‍❤️‍💋‍👨', category: 'Peoples', tags: ['couplekiss_man_man'] },
  {
    emoji: '👪',
    category: 'Peoples',
    tags: ['family_man_woman_boy', 'family'],
  },
  { emoji: '👨‍👩‍👧', category: 'Peoples', tags: ['family_man_woman_girl'] },
  { emoji: '👨‍👩‍👧‍👦', category: 'Peoples', tags: ['family_man_woman_girl_boy'] },
  { emoji: '👨‍👩‍👦‍👦', category: 'Peoples', tags: ['family_man_woman_boy_boy'] },
  { emoji: '👨‍👩‍👧‍👧', category: 'Peoples', tags: ['family_man_woman_girl_girl'] },
  { emoji: '👩‍👩‍👦', category: 'Peoples', tags: ['family_woman_woman_boy'] },
  { emoji: '👩‍👩‍👧', category: 'Peoples', tags: ['family_woman_woman_girl'] },
  { emoji: '👩‍👩‍👧‍👦', category: 'Peoples', tags: ['family_woman_woman_girl_boy'] },
  { emoji: '👩‍👩‍👦‍👦', category: 'Peoples', tags: ['family_woman_woman_boy_boy'] },
  { emoji: '👩‍👩‍👧‍👧', category: 'Peoples', tags: ['family_woman_woman_girl_girl'] },
  { emoji: '👨‍👨‍👦', category: 'Peoples', tags: ['family_man_man_boy'] },
  { emoji: '👨‍👨‍👧', category: 'Peoples', tags: ['family_man_man_girl'] },
  { emoji: '👨‍👨‍👧‍👦', category: 'Peoples', tags: ['family_man_man_girl_boy'] },
  { emoji: '👨‍👨‍👦‍👦', category: 'Peoples', tags: ['family_man_man_boy_boy'] },
  { emoji: '👨‍👨‍👧‍👧', category: 'Peoples', tags: ['family_man_man_girl_girl'] },
  { emoji: '👩‍👦', category: 'Peoples', tags: ['family_woman_boy'] },
  { emoji: '👩‍👧', category: 'Peoples', tags: ['family_woman_girl'] },
  { emoji: '👩‍👧‍👦', category: 'Peoples', tags: ['family_woman_girl_boy'] },
  { emoji: '👩‍👦‍👦', category: 'Peoples', tags: ['family_woman_boy_boy'] },
  { emoji: '👩‍👧‍👧', category: 'Peoples', tags: ['family_woman_girl_girl'] },
  { emoji: '👨‍👦', category: 'Peoples', tags: ['family_man_boy'] },
  { emoji: '👨‍👧', category: 'Peoples', tags: ['family_man_girl'] },
  { emoji: '👨‍👧‍👦', category: 'Peoples', tags: ['family_man_girl_boy'] },
  { emoji: '👨‍👦‍👦', category: 'Peoples', tags: ['family_man_boy_boy'] },
  { emoji: '👨‍👧‍👧', category: 'Peoples', tags: ['family_man_girl_girl'] },
  { emoji: '👚', category: 'Peoples', tags: ['womans_clothes'] },
  { emoji: '👕', category: 'Peoples', tags: ['shirt', 'tshirt'] },
  { emoji: '👖', category: 'Peoples', tags: ['jeans'] },
  { emoji: '👔', category: 'Peoples', tags: ['necktie'] },
  { emoji: '👗', category: 'Peoples', tags: ['dress'] },
  { emoji: '👙', category: 'Peoples', tags: ['bikini'] },
  { emoji: '👘', category: 'Peoples', tags: ['kimono'] },
  { emoji: '👠', category: 'Peoples', tags: ['high_heel'] },
  { emoji: '👡', category: 'Peoples', tags: ['sandal'] },
  { emoji: '👢', category: 'Peoples', tags: ['boot'] },
  { emoji: '👞', category: 'Peoples', tags: ['mans_shoe', 'shoe'] },
  { emoji: '👟', category: 'Peoples', tags: ['athletic_shoe'] },
  { emoji: '👒', category: 'Peoples', tags: ['womans_hat'] },
  { emoji: '🎩', category: 'Peoples', tags: ['tophat'] },
  { emoji: '🎓', category: 'Peoples', tags: ['mortar_board'] },
  { emoji: '👑', category: 'Peoples', tags: ['crown'] },
  { emoji: '⛑', category: 'Peoples', tags: ['rescue_worker_helmet'] },
  { emoji: '🎒', category: 'Peoples', tags: ['school_satchel'] },
  { emoji: '👝', category: 'Peoples', tags: ['pouch'] },
  { emoji: '👛', category: 'Peoples', tags: ['purse'] },
  { emoji: '👜', category: 'Peoples', tags: ['handbag'] },
  { emoji: '💼', category: 'Peoples', tags: ['briefcase'] },
  { emoji: '👓', category: 'Peoples', tags: ['eyeglasses'] },
  { emoji: '🕶', category: 'Peoples', tags: ['dark_sunglasses'] },
  { emoji: '🌂', category: 'Peoples', tags: ['closed_umbrella'] },
  { emoji: '☂️', category: 'Peoples', tags: ['open_umbrella'] },
  { emoji: '🐶', category: 'Nature', tags: ['dog'] },
  { emoji: '🐱', category: 'Nature', tags: ['cat'] },
  { emoji: '🐭', category: 'Nature', tags: ['mouse'] },
  { emoji: '🐹', category: 'Nature', tags: ['hamster'] },
  { emoji: '🐰', category: 'Nature', tags: ['rabbit'] },
  { emoji: '🦊', category: 'Nature', tags: ['fox_face'] },
  { emoji: '🐻', category: 'Nature', tags: ['bear'] },
  { emoji: '🐼', category: 'Nature', tags: ['panda_face'] },
  { emoji: '🐨', category: 'Nature', tags: ['koala'] },
  { emoji: '🐯', category: 'Nature', tags: ['tiger'] },
  { emoji: '🦁', category: 'Nature', tags: ['lion'] },
  { emoji: '🐮', category: 'Nature', tags: ['cow'] },
  { emoji: '🐷', category: 'Nature', tags: ['pig'] },
  { emoji: '🐽', category: 'Nature', tags: ['pig_nose'] },
  { emoji: '🐸', category: 'Nature', tags: ['frog'] },
  { emoji: '🐵', category: 'Nature', tags: ['monkey_face'] },
  { emoji: '🙈', category: 'Nature', tags: ['see_no_evil'] },
  { emoji: '🙉', category: 'Nature', tags: ['hear_no_evil'] },
  { emoji: '🙊', category: 'Nature', tags: ['speak_no_evil'] },
  { emoji: '🐒', category: 'Nature', tags: ['monkey'] },
  { emoji: '🐔', category: 'Nature', tags: ['chicken'] },
  { emoji: '🐧', category: 'Nature', tags: ['penguin'] },
  { emoji: '🐦', category: 'Nature', tags: ['bird'] },
  { emoji: '🐤', category: 'Nature', tags: ['baby_chick'] },
  { emoji: '🐣', category: 'Nature', tags: ['hatching_chick'] },
  { emoji: '🐥', category: 'Nature', tags: ['hatched_chick'] },
  { emoji: '🦆', category: 'Nature', tags: ['duck'] },
  { emoji: '🦅', category: 'Nature', tags: ['eagle'] },
  { emoji: '🦉', category: 'Nature', tags: ['owl'] },
  { emoji: '🦇', category: 'Nature', tags: ['bat'] },
  { emoji: '🐺', category: 'Nature', tags: ['wolf'] },
  { emoji: '🐗', category: 'Nature', tags: ['boar'] },
  { emoji: '🐴', category: 'Nature', tags: ['horse'] },
  { emoji: '🦄', category: 'Nature', tags: ['unicorn'] },
  { emoji: '🐝', category: 'Nature', tags: ['bee', 'honeybee'] },
  { emoji: '🐛', category: 'Nature', tags: ['bug'] },
  { emoji: '🦋', category: 'Nature', tags: ['butterfly'] },
  { emoji: '🐌', category: 'Nature', tags: ['snail'] },
  { emoji: '🐚', category: 'Nature', tags: ['shell'] },
  { emoji: '🐞', category: 'Nature', tags: ['beetle'] },
  { emoji: '🐜', category: 'Nature', tags: ['ant'] },
  { emoji: '🕷', category: 'Nature', tags: ['spider'] },
  { emoji: '🕸', category: 'Nature', tags: ['spider_web'] },
  { emoji: '🐢', category: 'Nature', tags: ['turtle'] },
  { emoji: '🐍', category: 'Nature', tags: ['snake'] },
  { emoji: '🦎', category: 'Nature', tags: ['lizard'] },
  { emoji: '🦂', category: 'Nature', tags: ['scorpion'] },
  { emoji: '🦀', category: 'Nature', tags: ['crab'] },
  { emoji: '🦑', category: 'Nature', tags: ['squid'] },
  { emoji: '🐙', category: 'Nature', tags: ['octopus'] },
  { emoji: '🦐', category: 'Nature', tags: ['shrimp'] },
  { emoji: '🐠', category: 'Nature', tags: ['tropical_fish'] },
  { emoji: '🐟', category: 'Nature', tags: ['fish'] },
  { emoji: '🐡', category: 'Nature', tags: ['blowfish'] },
  { emoji: '🐬', category: 'Nature', tags: ['dolphin', 'flipper'] },
  { emoji: '🦈', category: 'Nature', tags: ['shark'] },
  { emoji: '🐳', category: 'Nature', tags: ['whale'] },
  { emoji: '🐋', category: 'Nature', tags: ['whale2'] },
  { emoji: '🐊', category: 'Nature', tags: ['crocodile'] },
  { emoji: '🐆', category: 'Nature', tags: ['leopard'] },
  { emoji: '🐅', category: 'Nature', tags: ['tiger2'] },
  { emoji: '🐃', category: 'Nature', tags: ['water_buffalo'] },
  { emoji: '🐂', category: 'Nature', tags: ['ox'] },
  { emoji: '🐄', category: 'Nature', tags: ['cow2'] },
  { emoji: '🦌', category: 'Nature', tags: ['deer'] },
  { emoji: '🐪', category: 'Nature', tags: ['dromedary_camel'] },
  { emoji: '🐫', category: 'Nature', tags: ['camel'] },
  { emoji: '🐘', category: 'Nature', tags: ['elephant'] },
  { emoji: '🦏', category: 'Nature', tags: ['rhinoceros'] },
  { emoji: '🦍', category: 'Nature', tags: ['gorilla'] },
  { emoji: '🐎', category: 'Nature', tags: ['racehorse'] },
  { emoji: '🐖', category: 'Nature', tags: ['pig2'] },
  { emoji: '🐐', category: 'Nature', tags: ['goat'] },
  { emoji: '🐏', category: 'Nature', tags: ['ram'] },
  { emoji: '🐑', category: 'Nature', tags: ['sheep'] },
  { emoji: '🐕', category: 'Nature', tags: ['dog2'] },
  { emoji: '🐩', category: 'Nature', tags: ['poodle'] },
  { emoji: '🐈', category: 'Nature', tags: ['cat2'] },
  { emoji: '🐓', category: 'Nature', tags: ['rooster'] },
  { emoji: '🦃', category: 'Nature', tags: ['turkey'] },
  { emoji: '🕊', category: 'Nature', tags: ['dove'] },
  { emoji: '🐇', category: 'Nature', tags: ['rabbit2'] },
  { emoji: '🐁', category: 'Nature', tags: ['mouse2'] },
  { emoji: '🐀', category: 'Nature', tags: ['rat'] },
  { emoji: '🐿', category: 'Nature', tags: ['chipmunk'] },
  { emoji: '🐾', category: 'Nature', tags: ['feet', 'paw_prints'] },
  { emoji: '🐉', category: 'Nature', tags: ['dragon'] },
  { emoji: '🐲', category: 'Nature', tags: ['dragon_face'] },
  { emoji: '🌵', category: 'Nature', tags: ['cactus'] },
  { emoji: '🎄', category: 'Nature', tags: ['christmas_tree'] },
  { emoji: '🌲', category: 'Nature', tags: ['evergreen_tree'] },
  { emoji: '🌳', category: 'Nature', tags: ['deciduous_tree'] },
  { emoji: '🌴', category: 'Nature', tags: ['palm_tree'] },
  { emoji: '🌱', category: 'Nature', tags: ['seedling'] },
  { emoji: '🌿', category: 'Nature', tags: ['herb'] },
  { emoji: '☘️', category: 'Nature', tags: ['shamrock'] },
  { emoji: '🍀', category: 'Nature', tags: ['four_leaf_clover'] },
  { emoji: '🎍', category: 'Nature', tags: ['bamboo'] },
  { emoji: '🎋', category: 'Nature', tags: ['tanabata_tree'] },
  { emoji: '🍃', category: 'Nature', tags: ['leaves'] },
  { emoji: '🍂', category: 'Nature', tags: ['fallen_leaf'] },
  { emoji: '🍁', category: 'Nature', tags: ['maple_leaf'] },
  { emoji: '🍄', category: 'Nature', tags: ['mushroom'] },
  { emoji: '🌾', category: 'Nature', tags: ['ear_of_rice'] },
  { emoji: '💐', category: 'Nature', tags: ['bouquet'] },
  { emoji: '🌷', category: 'Nature', tags: ['tulip'] },
  { emoji: '🌹', category: 'Nature', tags: ['rose'] },
  { emoji: '🥀', category: 'Nature', tags: ['wilted_flower'] },
  { emoji: '🌻', category: 'Nature', tags: ['sunflower'] },
  { emoji: '🌼', category: 'Nature', tags: ['blossom'] },
  { emoji: '🌸', category: 'Nature', tags: ['cherry_blossom'] },
  { emoji: '🌺', category: 'Nature', tags: ['hibiscus'] },
  { emoji: '🌎', category: 'Nature', tags: ['earth_americas'] },
  { emoji: '🌍', category: 'Nature', tags: ['earth_africa'] },
  { emoji: '🌏', category: 'Nature', tags: ['earth_asia'] },
  { emoji: '🌕', category: 'Nature', tags: ['full_moon'] },
  { emoji: '🌖', category: 'Nature', tags: ['waning_gibbous_moon'] },
  { emoji: '🌗', category: 'Nature', tags: ['last_quarter_moon'] },
  { emoji: '🌘', category: 'Nature', tags: ['waning_crescent_moon'] },
  { emoji: '🌑', category: 'Nature', tags: ['new_moon'] },
  { emoji: '🌒', category: 'Nature', tags: ['waxing_crescent_moon'] },
  { emoji: '🌓', category: 'Nature', tags: ['first_quarter_moon'] },
  { emoji: '🌔', category: 'Nature', tags: ['moon', 'waxing_gibbous_moon'] },
  { emoji: '🌚', category: 'Nature', tags: ['new_moon_with_face'] },
  { emoji: '🌝', category: 'Nature', tags: ['full_moon_with_face'] },
  { emoji: '🌞', category: 'Nature', tags: ['sun_with_face'] },
  { emoji: '🌛', category: 'Nature', tags: ['first_quarter_moon_with_face'] },
  { emoji: '🌜', category: 'Nature', tags: ['last_quarter_moon_with_face'] },
  { emoji: '🌙', category: 'Nature', tags: ['crescent_moon'] },
  { emoji: '💫', category: 'Nature', tags: ['dizzy'] },
  { emoji: '⭐️', category: 'Nature', tags: ['star'] },
  { emoji: '🌟', category: 'Nature', tags: ['star2'] },
  { emoji: '✨', category: 'Nature', tags: ['sparkles'] },
  { emoji: '⚡️', category: 'Nature', tags: ['zap'] },
  { emoji: '🔥', category: 'Nature', tags: ['fire'] },
  { emoji: '💥', category: 'Nature', tags: ['boom', 'collision'] },
  { emoji: '☄', category: 'Nature', tags: ['comet'] },
  { emoji: '☀️', category: 'Nature', tags: ['sunny'] },
  { emoji: '🌤', category: 'Nature', tags: ['sun_behind_small_cloud'] },
  { emoji: '⛅️', category: 'Nature', tags: ['partly_sunny'] },
  { emoji: '🌥', category: 'Nature', tags: ['sun_behind_large_cloud'] },
  { emoji: '🌦', category: 'Nature', tags: ['sun_behind_rain_cloud'] },
  { emoji: '🌈', category: 'Nature', tags: ['rainbow'] },
  { emoji: '☁️', category: 'Nature', tags: ['cloud'] },
  { emoji: '🌧', category: 'Nature', tags: ['cloud_with_rain'] },
  { emoji: '⛈', category: 'Nature', tags: ['cloud_with_lightning_and_rain'] },
  { emoji: '🌩', category: 'Nature', tags: ['cloud_with_lightning'] },
  { emoji: '🌨', category: 'Nature', tags: ['cloud_with_snow'] },
  { emoji: '☃️', category: 'Nature', tags: ['snowman_with_snow'] },
  { emoji: '⛄️', category: 'Nature', tags: ['snowman'] },
  { emoji: '❄️', category: 'Nature', tags: ['snowflake'] },
  { emoji: '🌬', category: 'Nature', tags: ['wind_face'] },
  { emoji: '💨', category: 'Nature', tags: ['dash'] },
  { emoji: '🌪', category: 'Nature', tags: ['tornado'] },
  { emoji: '🌫', category: 'Nature', tags: ['fog'] },
  { emoji: '🌊', category: 'Nature', tags: ['ocean'] },
  { emoji: '💧', category: 'Nature', tags: ['droplet'] },
  { emoji: '💦', category: 'Nature', tags: ['sweat_drops'] },
  { emoji: '☔️', category: 'Nature', tags: ['umbrella'] },
  { emoji: '🍏', category: 'Foods', tags: ['green_apple'] },
  { emoji: '🍎', category: 'Foods', tags: ['apple'] },
  { emoji: '🍐', category: 'Foods', tags: ['pear'] },
  { emoji: '🍊', category: 'Foods', tags: ['tangerine', 'orange', 'mandarin'] },
  { emoji: '🍋', category: 'Foods', tags: ['lemon'] },
  { emoji: '🍌', category: 'Foods', tags: ['banana'] },
  { emoji: '🍉', category: 'Foods', tags: ['watermelon'] },
  { emoji: '🍇', category: 'Foods', tags: ['grapes'] },
  { emoji: '🍓', category: 'Foods', tags: ['strawberry'] },
  { emoji: '🍈', category: 'Foods', tags: ['melon'] },
  { emoji: '🍒', category: 'Foods', tags: ['cherries'] },
  { emoji: '🍑', category: 'Foods', tags: ['peach'] },
  { emoji: '🍍', category: 'Foods', tags: ['pineapple'] },
  { emoji: '🥝', category: 'Foods', tags: ['kiwi_fruit'] },
  { emoji: '🥑', category: 'Foods', tags: ['avocado'] },
  { emoji: '🍅', category: 'Foods', tags: ['tomato'] },
  { emoji: '🍆', category: 'Foods', tags: ['eggplant'] },
  { emoji: '🥒', category: 'Foods', tags: ['cucumber'] },
  { emoji: '🥕', category: 'Foods', tags: ['carrot'] },
  { emoji: '🌽', category: 'Foods', tags: ['corn'] },
  { emoji: '🌶', category: 'Foods', tags: ['hot_pepper'] },
  { emoji: '🥔', category: 'Foods', tags: ['potato'] },
  { emoji: '🍠', category: 'Foods', tags: ['sweet_potato'] },
  { emoji: '🌰', category: 'Foods', tags: ['chestnut'] },
  { emoji: '🥜', category: 'Foods', tags: ['peanuts'] },
  { emoji: '🍯', category: 'Foods', tags: ['honey_pot'] },
  { emoji: '🥐', category: 'Foods', tags: ['croissant'] },
  { emoji: '🍞', category: 'Foods', tags: ['bread'] },
  { emoji: '🥖', category: 'Foods', tags: ['baguette_bread'] },
  { emoji: '🧀', category: 'Foods', tags: ['cheese'] },
  { emoji: '🥚', category: 'Foods', tags: ['egg'] },
  { emoji: '🍳', category: 'Foods', tags: ['fried_egg'] },
  { emoji: '🥓', category: 'Foods', tags: ['bacon'] },
  { emoji: '🥞', category: 'Foods', tags: ['pancakes'] },
  { emoji: '🍤', category: 'Foods', tags: ['fried_shrimp'] },
  { emoji: '🍗', category: 'Foods', tags: ['poultry_leg'] },
  { emoji: '🍖', category: 'Foods', tags: ['meat_on_bone'] },
  { emoji: '🍕', category: 'Foods', tags: ['pizza'] },
  { emoji: '🌭', category: 'Foods', tags: ['hotdog'] },
  { emoji: '🍔', category: 'Foods', tags: ['hamburger'] },
  { emoji: '🍟', category: 'Foods', tags: ['fries'] },
  { emoji: '🥙', category: 'Foods', tags: ['stuffed_flatbread'] },
  { emoji: '🌮', category: 'Foods', tags: ['taco'] },
  { emoji: '🌯', category: 'Foods', tags: ['burrito'] },
  { emoji: '🥗', category: 'Foods', tags: ['green_salad'] },
  { emoji: '🥘', category: 'Foods', tags: ['shallow_pan_of_food'] },
  { emoji: '🍝', category: 'Foods', tags: ['spaghetti'] },
  { emoji: '🍜', category: 'Foods', tags: ['ramen'] },
  { emoji: '🍲', category: 'Foods', tags: ['stew'] },
  { emoji: '🍥', category: 'Foods', tags: ['fish_cake'] },
  { emoji: '🍣', category: 'Foods', tags: ['sushi'] },
  { emoji: '🍱', category: 'Foods', tags: ['bento'] },
  { emoji: '🍛', category: 'Foods', tags: ['curry'] },
  { emoji: '🍚', category: 'Foods', tags: ['rice'] },
  { emoji: '🍙', category: 'Foods', tags: ['rice_ball'] },
  { emoji: '🍘', category: 'Foods', tags: ['rice_cracker'] },
  { emoji: '🍢', category: 'Foods', tags: ['oden'] },
  { emoji: '🍡', category: 'Foods', tags: ['dango'] },
  { emoji: '🍧', category: 'Foods', tags: ['shaved_ice'] },
  { emoji: '🍨', category: 'Foods', tags: ['ice_cream'] },
  { emoji: '🍦', category: 'Foods', tags: ['icecream'] },
  { emoji: '🍰', category: 'Foods', tags: ['cake'] },
  { emoji: '🎂', category: 'Foods', tags: ['birthday'] },
  { emoji: '🍮', category: 'Foods', tags: ['custard'] },
  { emoji: '🍭', category: 'Foods', tags: ['lollipop'] },
  { emoji: '🍬', category: 'Foods', tags: ['candy'] },
  { emoji: '🍫', category: 'Foods', tags: ['chocolate_bar'] },
  { emoji: '🍿', category: 'Foods', tags: ['popcorn'] },
  { emoji: '🍩', category: 'Foods', tags: ['doughnut'] },
  { emoji: '🍪', category: 'Foods', tags: ['cookie'] },
  { emoji: '🥛', category: 'Foods', tags: ['milk_glass'] },
  { emoji: '🍼', category: 'Foods', tags: ['baby_bottle'] },
  { emoji: '☕️', category: 'Foods', tags: ['coffee'] },
  { emoji: '🍵', category: 'Foods', tags: ['tea'] },
  { emoji: '🍶', category: 'Foods', tags: ['sake'] },
  { emoji: '🍺', category: 'Foods', tags: ['beer'] },
  { emoji: '🍻', category: 'Foods', tags: ['beers'] },
  { emoji: '🥂', category: 'Foods', tags: ['clinking_glasses'] },
  { emoji: '🍷', category: 'Foods', tags: ['wine_glass'] },
  { emoji: '🥃', category: 'Foods', tags: ['tumbler_glass'] },
  { emoji: '🍸', category: 'Foods', tags: ['cocktail'] },
  { emoji: '🍹', category: 'Foods', tags: ['tropical_drink'] },
  { emoji: '🍾', category: 'Foods', tags: ['champagne'] },
  { emoji: '🥄', category: 'Foods', tags: ['spoon'] },
  { emoji: '🍴', category: 'Foods', tags: ['fork_and_knife'] },
  { emoji: '🍽', category: 'Foods', tags: ['plate_with_cutlery'] },
  { emoji: '⚽️', category: 'Activity', tags: ['soccer'] },
  { emoji: '🏀', category: 'Activity', tags: ['basketball'] },
  { emoji: '🏈', category: 'Activity', tags: ['football'] },
  { emoji: '⚾️', category: 'Activity', tags: ['baseball'] },
  { emoji: '🎾', category: 'Activity', tags: ['tennis'] },
  { emoji: '🏐', category: 'Activity', tags: ['volleyball'] },
  { emoji: '🏉', category: 'Activity', tags: ['rugby_football'] },
  { emoji: '🎱', category: 'Activity', tags: ['8ball'] },
  { emoji: '🏓', category: 'Activity', tags: ['ping_pong'] },
  { emoji: '🏸', category: 'Activity', tags: ['badminton'] },
  { emoji: '🥅', category: 'Activity', tags: ['goal_net'] },
  { emoji: '🏒', category: 'Activity', tags: ['ice_hockey'] },
  { emoji: '🏑', category: 'Activity', tags: ['field_hockey'] },
  { emoji: '🏏', category: 'Activity', tags: ['cricket'] },
  { emoji: '⛳️', category: 'Activity', tags: ['golf'] },
  { emoji: '🏹', category: 'Activity', tags: ['bow_and_arrow'] },
  { emoji: '🎣', category: 'Activity', tags: ['fishing_pole_and_fish'] },
  { emoji: '🥊', category: 'Activity', tags: ['boxing_glove'] },
  { emoji: '🥋', category: 'Activity', tags: ['martial_arts_uniform'] },
  { emoji: '⛸', category: 'Activity', tags: ['ice_skate'] },
  { emoji: '🎿', category: 'Activity', tags: ['ski'] },
  { emoji: '⛷', category: 'Activity', tags: ['skier'] },
  { emoji: '🏂', category: 'Activity', tags: ['snowboarder'] },
  { emoji: '🏋️‍♀️', category: 'Activity', tags: ['weight_lifting_woman'] },
  { emoji: '🏋', category: 'Activity', tags: ['weight_lifting_man'] },
  { emoji: '🤺', category: 'Activity', tags: ['person_fencing'] },
  { emoji: '🤼‍♀', category: 'Activity', tags: ['women_wrestling'] },
  { emoji: '🤼‍♂', category: 'Activity', tags: ['men_wrestling'] },
  { emoji: '🤸‍♀', category: 'Activity', tags: ['woman_cartwheeling'] },
  { emoji: '🤸‍♂', category: 'Activity', tags: ['man_cartwheeling'] },
  { emoji: '⛹️‍♀️', category: 'Activity', tags: ['basketball_woman'] },
  { emoji: '⛹', category: 'Activity', tags: ['basketball_man'] },
  { emoji: '🤾‍♀', category: 'Activity', tags: ['woman_playing_handball'] },
  { emoji: '🤾‍♂', category: 'Activity', tags: ['man_playing_handball'] },
  { emoji: '🏌️‍♀️', category: 'Activity', tags: ['golfing_woman'] },
  { emoji: '🏌', category: 'Activity', tags: ['golfing_man'] },
  { emoji: '🏄‍♀', category: 'Activity', tags: ['surfing_woman'] },
  { emoji: '🏄', category: 'Activity', tags: ['surfing_man', 'surfer'] },
  { emoji: '🏊‍♀', category: 'Activity', tags: ['swimming_woman'] },
  { emoji: '🏊', category: 'Activity', tags: ['swimming_man', 'swimmer'] },
  { emoji: '🤽‍♀', category: 'Activity', tags: ['woman_playing_water_polo'] },
  { emoji: '🤽‍♂', category: 'Activity', tags: ['man_playing_water_polo'] },
  { emoji: '🚣‍♀', category: 'Activity', tags: ['rowing_woman'] },
  { emoji: '🚣', category: 'Activity', tags: ['rowing_man', 'rowboat'] },
  { emoji: '🏇', category: 'Activity', tags: ['horse_racing'] },
  { emoji: '🚴‍♀', category: 'Activity', tags: ['biking_woman'] },
  { emoji: '🚴', category: 'Activity', tags: ['biking_man', 'bicyclist'] },
  { emoji: '🚵‍♀', category: 'Activity', tags: ['mountain_biking_woman'] },
  {
    emoji: '🚵',
    category: 'Activity',
    tags: ['mountain_biking_man', 'mountain_bicyclist'],
  },
  { emoji: '🎽', category: 'Activity', tags: ['running_shirt_with_sash'] },
  { emoji: '🏅', category: 'Activity', tags: ['medal_sports'] },
  { emoji: '🎖', category: 'Activity', tags: ['medal_military'] },
  { emoji: '🥇', category: 'Activity', tags: ['1st_place_medal'] },
  { emoji: '🥈', category: 'Activity', tags: ['2nd_place_medal'] },
  { emoji: '🥉', category: 'Activity', tags: ['3rd_place_medal'] },
  { emoji: '🏆', category: 'Activity', tags: ['trophy'] },
  { emoji: '🏵', category: 'Activity', tags: ['rosette'] },
  { emoji: '🎗', category: 'Activity', tags: ['reminder_ribbon'] },
  { emoji: '🎫', category: 'Activity', tags: ['ticket'] },
  { emoji: '🎟', category: 'Activity', tags: ['tickets'] },
  { emoji: '🎪', category: 'Activity', tags: ['circus_tent'] },
  { emoji: '🤹‍♀', category: 'Activity', tags: ['woman_juggling'] },
  { emoji: '🤹‍♂', category: 'Activity', tags: ['man_juggling'] },
  { emoji: '🎭', category: 'Activity', tags: ['performing_arts'] },
  { emoji: '🎨', category: 'Activity', tags: ['art'] },
  { emoji: '🎬', category: 'Activity', tags: ['clapper'] },
  { emoji: '🎤', category: 'Activity', tags: ['microphone'] },
  { emoji: '🎧', category: 'Activity', tags: ['headphones'] },
  { emoji: '🎼', category: 'Activity', tags: ['musical_score'] },
  { emoji: '🎹', category: 'Activity', tags: ['musical_keyboard'] },
  { emoji: '🥁', category: 'Activity', tags: ['drum'] },
  { emoji: '🎷', category: 'Activity', tags: ['saxophone'] },
  { emoji: '🎺', category: 'Activity', tags: ['trumpet'] },
  { emoji: '🎸', category: 'Activity', tags: ['guitar'] },
  { emoji: '🎻', category: 'Activity', tags: ['violin'] },
  { emoji: '🎲', category: 'Activity', tags: ['game_die'] },
  { emoji: '🎯', category: 'Activity', tags: ['dart'] },
  { emoji: '🎳', category: 'Activity', tags: ['bowling'] },
  { emoji: '🎮', category: 'Activity', tags: ['video_game'] },
  { emoji: '🎰', category: 'Activity', tags: ['slot_machine'] },
  { emoji: '🚗', category: 'Places', tags: ['car', 'red_car'] },
  { emoji: '🚕', category: 'Places', tags: ['taxi'] },
  { emoji: '🚙', category: 'Places', tags: ['blue_car'] },
  { emoji: '🚌', category: 'Places', tags: ['bus'] },
  { emoji: '🚎', category: 'Places', tags: ['trolleybus'] },
  { emoji: '🏎', category: 'Places', tags: ['racing_car'] },
  { emoji: '🚓', category: 'Places', tags: ['police_car'] },
  { emoji: '🚑', category: 'Places', tags: ['ambulance'] },
  { emoji: '🚒', category: 'Places', tags: ['fire_engine'] },
  { emoji: '🚐', category: 'Places', tags: ['minibus'] },
  { emoji: '🚚', category: 'Places', tags: ['truck'] },
  { emoji: '🚛', category: 'Places', tags: ['articulated_lorry'] },
  { emoji: '🚜', category: 'Places', tags: ['tractor'] },
  { emoji: '🛴', category: 'Places', tags: ['kick_scooter'] },
  { emoji: '🚲', category: 'Places', tags: ['bike'] },
  { emoji: '🛵', category: 'Places', tags: ['motor_scooter'] },
  { emoji: '🏍', category: 'Places', tags: ['motorcycle'] },
  { emoji: '🚨', category: 'Places', tags: ['rotating_light'] },
  { emoji: '🚔', category: 'Places', tags: ['oncoming_police_car'] },
  { emoji: '🚍', category: 'Places', tags: ['oncoming_bus'] },
  { emoji: '🚘', category: 'Places', tags: ['oncoming_automobile'] },
  { emoji: '🚖', category: 'Places', tags: ['oncoming_taxi'] },
  { emoji: '🚡', category: 'Places', tags: ['aerial_tramway'] },
  { emoji: '🚠', category: 'Places', tags: ['mountain_cableway'] },
  { emoji: '🚟', category: 'Places', tags: ['suspension_railway'] },
  { emoji: '🚃', category: 'Places', tags: ['railway_car'] },
  { emoji: '🚋', category: 'Places', tags: ['train'] },
  { emoji: '🚞', category: 'Places', tags: ['mountain_railway'] },
  { emoji: '🚝', category: 'Places', tags: ['monorail'] },
  { emoji: '🚄', category: 'Places', tags: ['bullettrain_side'] },
  { emoji: '🚅', category: 'Places', tags: ['bullettrain_front'] },
  { emoji: '🚈', category: 'Places', tags: ['light_rail'] },
  { emoji: '🚂', category: 'Places', tags: ['steam_locomotive'] },
  { emoji: '🚆', category: 'Places', tags: ['train2'] },
  { emoji: '🚇', category: 'Places', tags: ['metro'] },
  { emoji: '🚊', category: 'Places', tags: ['tram'] },
  { emoji: '🚉', category: 'Places', tags: ['station'] },
  { emoji: '🚁', category: 'Places', tags: ['helicopter'] },
  { emoji: '🛩', category: 'Places', tags: ['small_airplane'] },
  { emoji: '✈️', category: 'Places', tags: ['airplane'] },
  { emoji: '🛫', category: 'Places', tags: ['flight_departure'] },
  { emoji: '🛬', category: 'Places', tags: ['flight_arrival'] },
  { emoji: '🚀', category: 'Places', tags: ['rocket'] },
  { emoji: '🛰', category: 'Places', tags: ['artificial_satellite'] },
  { emoji: '💺', category: 'Places', tags: ['seat'] },
  { emoji: '🛶', category: 'Places', tags: ['canoe'] },
  { emoji: '⛵️', category: 'Places', tags: ['boat', 'sailboat'] },
  { emoji: '🛥', category: 'Places', tags: ['motor_boat'] },
  { emoji: '🚤', category: 'Places', tags: ['speedboat'] },
  { emoji: '🛳', category: 'Places', tags: ['passenger_ship'] },
  { emoji: '⛴', category: 'Places', tags: ['ferry'] },
  { emoji: '🚢', category: 'Places', tags: ['ship'] },
  { emoji: '⚓️', category: 'Places', tags: ['anchor'] },
  { emoji: '🚧', category: 'Places', tags: ['construction'] },
  { emoji: '⛽️', category: 'Places', tags: ['fuelpump'] },
  { emoji: '🚏', category: 'Places', tags: ['busstop'] },
  { emoji: '🚦', category: 'Places', tags: ['vertical_traffic_light'] },
  { emoji: '🚥', category: 'Places', tags: ['traffic_light'] },
  { emoji: '🗺', category: 'Places', tags: ['world_map'] },
  { emoji: '🗿', category: 'Places', tags: ['moyai'] },
  { emoji: '🗽', category: 'Places', tags: ['statue_of_liberty'] },
  { emoji: '⛲️', category: 'Places', tags: ['fountain'] },
  { emoji: '🗼', category: 'Places', tags: ['tokyo_tower'] },
  { emoji: '🏰', category: 'Places', tags: ['european_castle'] },
  { emoji: '🏯', category: 'Places', tags: ['japanese_castle'] },
  { emoji: '🏟', category: 'Places', tags: ['stadium'] },
  { emoji: '🎡', category: 'Places', tags: ['ferris_wheel'] },
  { emoji: '🎢', category: 'Places', tags: ['roller_coaster'] },
  { emoji: '🎠', category: 'Places', tags: ['carousel_horse'] },
  { emoji: '⛱', category: 'Places', tags: ['parasol_on_ground'] },
  { emoji: '🏖', category: 'Places', tags: ['beach_umbrella'] },
  { emoji: '🏝', category: 'Places', tags: ['desert_island'] },
  { emoji: '⛰', category: 'Places', tags: ['mountain'] },
  { emoji: '🏔', category: 'Places', tags: ['mountain_snow'] },
  { emoji: '🗻', category: 'Places', tags: ['mount_fuji'] },
  { emoji: '🌋', category: 'Places', tags: ['volcano'] },
  { emoji: '🏜', category: 'Places', tags: ['desert'] },
  { emoji: '🏕', category: 'Places', tags: ['camping'] },
  { emoji: '⛺️', category: 'Places', tags: ['tent'] },
  { emoji: '🛤', category: 'Places', tags: ['railway_track'] },
  { emoji: '🛣', category: 'Places', tags: ['motorway'] },
  { emoji: '🏗', category: 'Places', tags: ['building_construction'] },
  { emoji: '🏭', category: 'Places', tags: ['factory'] },
  { emoji: '🏠', category: 'Places', tags: ['house'] },
  { emoji: '🏡', category: 'Places', tags: ['house_with_garden'] },
  { emoji: '🏘', category: 'Places', tags: ['houses'] },
  { emoji: '🏚', category: 'Places', tags: ['derelict_house'] },
  { emoji: '🏢', category: 'Places', tags: ['office'] },
  { emoji: '🏬', category: 'Places', tags: ['department_store'] },
  { emoji: '🏣', category: 'Places', tags: ['post_office'] },
  { emoji: '🏤', category: 'Places', tags: ['european_post_office'] },
  { emoji: '🏥', category: 'Places', tags: ['hospital'] },
  { emoji: '🏦', category: 'Places', tags: ['bank'] },
  { emoji: '🏨', category: 'Places', tags: ['hotel'] },
  { emoji: '🏪', category: 'Places', tags: ['convenience_store'] },
  { emoji: '🏫', category: 'Places', tags: ['school'] },
  { emoji: '🏩', category: 'Places', tags: ['love_hotel'] },
  { emoji: '💒', category: 'Places', tags: ['wedding'] },
  { emoji: '🏛', category: 'Places', tags: ['classical_building'] },
  { emoji: '⛪️', category: 'Places', tags: ['church'] },
  { emoji: '🕌', category: 'Places', tags: ['mosque'] },
  { emoji: '🕍', category: 'Places', tags: ['synagogue'] },
  { emoji: '🕋', category: 'Places', tags: ['kaaba'] },
  { emoji: '⛩', category: 'Places', tags: ['shinto_shrine'] },
  { emoji: '🗾', category: 'Places', tags: ['japan'] },
  { emoji: '🎑', category: 'Places', tags: ['rice_scene'] },
  { emoji: '🏞', category: 'Places', tags: ['national_park'] },
  { emoji: '🌅', category: 'Places', tags: ['sunrise'] },
  { emoji: '🌄', category: 'Places', tags: ['sunrise_over_mountains'] },
  { emoji: '🌠', category: 'Places', tags: ['stars'] },
  { emoji: '🎇', category: 'Places', tags: ['sparkler'] },
  { emoji: '🎆', category: 'Places', tags: ['fireworks'] },
  { emoji: '🌇', category: 'Places', tags: ['city_sunrise'] },
  { emoji: '🌆', category: 'Places', tags: ['city_sunset'] },
  { emoji: '🏙', category: 'Places', tags: ['cityscape'] },
  { emoji: '🌃', category: 'Places', tags: ['night_with_stars'] },
  { emoji: '🌌', category: 'Places', tags: ['milky_way'] },
  { emoji: '🌉', category: 'Places', tags: ['bridge_at_night'] },
  { emoji: '🌁', category: 'Places', tags: ['foggy'] },
  { emoji: '⌚️', category: 'Objects', tags: ['watch'] },
  { emoji: '📱', category: 'Objects', tags: ['iphone'] },
  { emoji: '📲', category: 'Objects', tags: ['calling'] },
  { emoji: '💻', category: 'Objects', tags: ['computer'] },
  { emoji: '⌨️', category: 'Objects', tags: ['keyboard'] },
  { emoji: '🖥', category: 'Objects', tags: ['desktop_computer'] },
  { emoji: '🖨', category: 'Objects', tags: ['printer'] },
  { emoji: '🖱', category: 'Objects', tags: ['computer_mouse'] },
  { emoji: '🖲', category: 'Objects', tags: ['trackball'] },
  { emoji: '🕹', category: 'Objects', tags: ['joystick'] },
  { emoji: '🗜', category: 'Objects', tags: ['clamp'] },
  { emoji: '💽', category: 'Objects', tags: ['minidisc'] },
  { emoji: '💾', category: 'Objects', tags: ['floppy_disk'] },
  { emoji: '💿', category: 'Objects', tags: ['cd'] },
  { emoji: '📀', category: 'Objects', tags: ['dvd'] },
  { emoji: '📼', category: 'Objects', tags: ['vhs'] },
  { emoji: '📷', category: 'Objects', tags: ['camera'] },
  { emoji: '📸', category: 'Objects', tags: ['camera_flash'] },
  { emoji: '📹', category: 'Objects', tags: ['video_camera'] },
  { emoji: '🎥', category: 'Objects', tags: ['movie_camera'] },
  { emoji: '📽', category: 'Objects', tags: ['film_projector'] },
  { emoji: '🎞', category: 'Objects', tags: ['film_strip'] },
  { emoji: '📞', category: 'Objects', tags: ['telephone_receiver'] },
  { emoji: '☎️', category: 'Objects', tags: ['phone', 'telephone'] },
  { emoji: '📟', category: 'Objects', tags: ['pager'] },
  { emoji: '📠', category: 'Objects', tags: ['fax'] },
  { emoji: '📺', category: 'Objects', tags: ['tv'] },
  { emoji: '📻', category: 'Objects', tags: ['radio'] },
  { emoji: '🎙', category: 'Objects', tags: ['studio_microphone'] },
  { emoji: '🎚', category: 'Objects', tags: ['level_slider'] },
  { emoji: '🎛', category: 'Objects', tags: ['control_knobs'] },
  { emoji: '⏱', category: 'Objects', tags: ['stopwatch'] },
  { emoji: '⏲', category: 'Objects', tags: ['timer_clock'] },
  { emoji: '⏰', category: 'Objects', tags: ['alarm_clock'] },
  { emoji: '🕰', category: 'Objects', tags: ['mantelpiece_clock'] },
  { emoji: '⌛️', category: 'Objects', tags: ['hourglass'] },
  { emoji: '⏳', category: 'Objects', tags: ['hourglass_flowing_sand'] },
  { emoji: '📡', category: 'Objects', tags: ['satellite'] },
  { emoji: '🔋', category: 'Objects', tags: ['battery'] },
  { emoji: '🔌', category: 'Objects', tags: ['electric_plug'] },
  { emoji: '💡', category: 'Objects', tags: ['bulb'] },
  { emoji: '🔦', category: 'Objects', tags: ['flashlight'] },
  { emoji: '🕯', category: 'Objects', tags: ['candle'] },
  { emoji: '🗑', category: 'Objects', tags: ['wastebasket'] },
  { emoji: '🛢', category: 'Objects', tags: ['oil_drum'] },
  { emoji: '💸', category: 'Objects', tags: ['money_with_wings'] },
  { emoji: '💵', category: 'Objects', tags: ['dollar'] },
  { emoji: '💴', category: 'Objects', tags: ['yen'] },
  { emoji: '💶', category: 'Objects', tags: ['euro'] },
  { emoji: '💷', category: 'Objects', tags: ['pound'] },
  { emoji: '💰', category: 'Objects', tags: ['moneybag'] },
  { emoji: '💳', category: 'Objects', tags: ['credit_card'] },
  { emoji: '💎', category: 'Objects', tags: ['gem'] },
  { emoji: '⚖️', category: 'Objects', tags: ['balance_scale'] },
  { emoji: '🔧', category: 'Objects', tags: ['wrench'] },
  { emoji: '🔨', category: 'Objects', tags: ['hammer'] },
  { emoji: '⚒', category: 'Objects', tags: ['hammer_and_pick'] },
  { emoji: '🛠', category: 'Objects', tags: ['hammer_and_wrench'] },
  { emoji: '⛏', category: 'Objects', tags: ['pick'] },
  { emoji: '🔩', category: 'Objects', tags: ['nut_and_bolt'] },
  { emoji: '⚙️', category: 'Objects', tags: ['gear'] },
  { emoji: '⛓', category: 'Objects', tags: ['chains'] },
  { emoji: '🔫', category: 'Objects', tags: ['gun'] },
  { emoji: '💣', category: 'Objects', tags: ['bomb'] },
  { emoji: '🔪', category: 'Objects', tags: ['hocho', 'knife'] },
  { emoji: '🗡', category: 'Objects', tags: ['dagger'] },
  { emoji: '⚔️', category: 'Objects', tags: ['crossed_swords'] },
  { emoji: '🛡', category: 'Objects', tags: ['shield'] },
  { emoji: '🚬', category: 'Objects', tags: ['smoking'] },
  { emoji: '⚰️', category: 'Objects', tags: ['coffin'] },
  { emoji: '⚱️', category: 'Objects', tags: ['funeral_urn'] },
  { emoji: '🏺', category: 'Objects', tags: ['amphora'] },
  { emoji: '🔮', category: 'Objects', tags: ['crystal_ball'] },
  { emoji: '📿', category: 'Objects', tags: ['prayer_beads'] },
  { emoji: '💈', category: 'Objects', tags: ['barber'] },
  { emoji: '⚗️', category: 'Objects', tags: ['alembic'] },
  { emoji: '🔭', category: 'Objects', tags: ['telescope'] },
  { emoji: '🔬', category: 'Objects', tags: ['microscope'] },
  { emoji: '🕳', category: 'Objects', tags: ['hole'] },
  { emoji: '💊', category: 'Objects', tags: ['pill'] },
  { emoji: '💉', category: 'Objects', tags: ['syringe'] },
  { emoji: '🌡', category: 'Objects', tags: ['thermometer'] },
  { emoji: '🚽', category: 'Objects', tags: ['toilet'] },
  { emoji: '🚰', category: 'Objects', tags: ['potable_water'] },
  { emoji: '🚿', category: 'Objects', tags: ['shower'] },
  { emoji: '🛁', category: 'Objects', tags: ['bathtub'] },
  { emoji: '🛀', category: 'Objects', tags: ['bath'] },
  { emoji: '🛎', category: 'Objects', tags: ['bellhop_bell'] },
  { emoji: '🔑', category: 'Objects', tags: ['key'] },
  { emoji: '🗝', category: 'Objects', tags: ['old_key'] },
  { emoji: '🚪', category: 'Objects', tags: ['door'] },
  { emoji: '🛋', category: 'Objects', tags: ['couch_and_lamp'] },
  { emoji: '🛏', category: 'Objects', tags: ['bed'] },
  { emoji: '🛌', category: 'Objects', tags: ['sleeping_bed'] },
  { emoji: '🖼', category: 'Objects', tags: ['framed_picture'] },
  { emoji: '🛍', category: 'Objects', tags: ['shopping'] },
  { emoji: '🛒', category: 'Objects', tags: ['shopping_cart'] },
  { emoji: '🎁', category: 'Objects', tags: ['gift'] },
  { emoji: '🎈', category: 'Objects', tags: ['balloon'] },
  { emoji: '🎏', category: 'Objects', tags: ['flags'] },
  { emoji: '🎀', category: 'Objects', tags: ['ribbon'] },
  { emoji: '🎊', category: 'Objects', tags: ['confetti_ball'] },
  { emoji: '🎉', category: 'Objects', tags: ['tada'] },
  { emoji: '🎎', category: 'Objects', tags: ['dolls'] },
  { emoji: '🏮', category: 'Objects', tags: ['izakaya_lantern', 'lantern'] },
  { emoji: '🎐', category: 'Objects', tags: ['wind_chime'] },
  { emoji: '✉️', category: 'Objects', tags: ['email', 'envelope'] },
  { emoji: '📩', category: 'Objects', tags: ['envelope_with_arrow'] },
  { emoji: '📨', category: 'Objects', tags: ['incoming_envelope'] },
  { emoji: '📧', category: 'Objects', tags: ['e-mail'] },
  { emoji: '💌', category: 'Objects', tags: ['love_letter'] },
  { emoji: '📥', category: 'Objects', tags: ['inbox_tray'] },
  { emoji: '📤', category: 'Objects', tags: ['outbox_tray'] },
  { emoji: '📦', category: 'Objects', tags: ['package'] },
  { emoji: '🏷', category: 'Objects', tags: ['label'] },
  { emoji: '📪', category: 'Objects', tags: ['mailbox_closed'] },
  { emoji: '📫', category: 'Objects', tags: ['mailbox'] },
  { emoji: '📬', category: 'Objects', tags: ['mailbox_with_mail'] },
  { emoji: '📭', category: 'Objects', tags: ['mailbox_with_no_mail'] },
  { emoji: '📮', category: 'Objects', tags: ['postbox'] },
  { emoji: '📯', category: 'Objects', tags: ['postal_horn'] },
  { emoji: '📜', category: 'Objects', tags: ['scroll'] },
  { emoji: '📃', category: 'Objects', tags: ['page_with_curl'] },
  { emoji: '📄', category: 'Objects', tags: ['page_facing_up'] },
  { emoji: '📑', category: 'Objects', tags: ['bookmark_tabs'] },
  { emoji: '📊', category: 'Objects', tags: ['bar_chart'] },
  { emoji: '📈', category: 'Objects', tags: ['chart_with_upwards_trend'] },
  { emoji: '📉', category: 'Objects', tags: ['chart_with_downwards_trend'] },
  { emoji: '🗒', category: 'Objects', tags: ['spiral_notepad'] },
  { emoji: '🗓', category: 'Objects', tags: ['spiral_calendar'] },
  { emoji: '📆', category: 'Objects', tags: ['calendar'] },
  { emoji: '📅', category: 'Objects', tags: ['date'] },
  { emoji: '📇', category: 'Objects', tags: ['card_index'] },
  { emoji: '🗃', category: 'Objects', tags: ['card_file_box'] },
  { emoji: '🗳', category: 'Objects', tags: ['ballot_box'] },
  { emoji: '🗄', category: 'Objects', tags: ['file_cabinet'] },
  { emoji: '📋', category: 'Objects', tags: ['clipboard'] },
  { emoji: '📁', category: 'Objects', tags: ['file_folder'] },
  { emoji: '📂', category: 'Objects', tags: ['open_file_folder'] },
  { emoji: '🗂', category: 'Objects', tags: ['card_index_dividers'] },
  { emoji: '🗞', category: 'Objects', tags: ['newspaper_roll'] },
  { emoji: '📰', category: 'Objects', tags: ['newspaper'] },
  { emoji: '📓', category: 'Objects', tags: ['notebook'] },
  {
    emoji: '📔',
    category: 'Objects',
    tags: ['notebook_with_decorative_cover'],
  },
  { emoji: '📒', category: 'Objects', tags: ['ledger'] },
  { emoji: '📕', category: 'Objects', tags: ['closed_book'] },
  { emoji: '📗', category: 'Objects', tags: ['green_book'] },
  { emoji: '📘', category: 'Objects', tags: ['blue_book'] },
  { emoji: '📙', category: 'Objects', tags: ['orange_book'] },
  { emoji: '📚', category: 'Objects', tags: ['books'] },
  { emoji: '📖', category: 'Objects', tags: ['book', 'open_book'] },
  { emoji: '🔖', category: 'Objects', tags: ['bookmark'] },
  { emoji: '🔗', category: 'Objects', tags: ['link'] },
  { emoji: '📎', category: 'Objects', tags: ['paperclip'] },
  { emoji: '🖇', category: 'Objects', tags: ['paperclips'] },
  { emoji: '📐', category: 'Objects', tags: ['triangular_ruler'] },
  { emoji: '📏', category: 'Objects', tags: ['straight_ruler'] },
  { emoji: '📌', category: 'Objects', tags: ['pushpin'] },
  { emoji: '📍', category: 'Objects', tags: ['round_pushpin'] },
  { emoji: '✂️', category: 'Objects', tags: ['scissors'] },
  { emoji: '🖊', category: 'Objects', tags: ['pen'] },
  { emoji: '🖋', category: 'Objects', tags: ['fountain_pen'] },
  { emoji: '✒️', category: 'Objects', tags: ['black_nib'] },
  { emoji: '🖌', category: 'Objects', tags: ['paintbrush'] },
  { emoji: '🖍', category: 'Objects', tags: ['crayon'] },
  { emoji: '📝', category: 'Objects', tags: ['memo', 'pencil'] },
  { emoji: '✏️', category: 'Objects', tags: ['pencil2'] },
  { emoji: '🔍', category: 'Objects', tags: ['mag'] },
  { emoji: '🔎', category: 'Objects', tags: ['mag_right'] },
  { emoji: '🔏', category: 'Objects', tags: ['lock_with_ink_pen'] },
  { emoji: '🔐', category: 'Objects', tags: ['closed_lock_with_key'] },
  { emoji: '🔒', category: 'Objects', tags: ['lock'] },
  { emoji: '🔓', category: 'Objects', tags: ['unlock'] },
  { emoji: '❤️', category: 'Symbols', tags: ['heart'] },
  { emoji: '💛', category: 'Symbols', tags: ['yellow_heart'] },
  { emoji: '💚', category: 'Symbols', tags: ['green_heart'] },
  { emoji: '💙', category: 'Symbols', tags: ['blue_heart'] },
  { emoji: '💜', category: 'Symbols', tags: ['purple_heart'] },
  { emoji: '🖤', category: 'Symbols', tags: ['black_heart'] },
  { emoji: '💔', category: 'Symbols', tags: ['broken_heart'] },
  { emoji: '❣️', category: 'Symbols', tags: ['heavy_heart_exclamation'] },
  { emoji: '💕', category: 'Symbols', tags: ['two_hearts'] },
  { emoji: '💞', category: 'Symbols', tags: ['revolving_hearts'] },
  { emoji: '💓', category: 'Symbols', tags: ['heartbeat'] },
  { emoji: '💗', category: 'Symbols', tags: ['heartpulse'] },
  { emoji: '💖', category: 'Symbols', tags: ['sparkling_heart'] },
  { emoji: '💘', category: 'Symbols', tags: ['cupid'] },
  { emoji: '💝', category: 'Symbols', tags: ['gift_heart'] },
  { emoji: '💟', category: 'Symbols', tags: ['heart_decoration'] },
  { emoji: '☮️', category: 'Symbols', tags: ['peace_symbol'] },
  { emoji: '✝️', category: 'Symbols', tags: ['latin_cross'] },
  { emoji: '☪️', category: 'Symbols', tags: ['star_and_crescent'] },
  { emoji: '🕉', category: 'Symbols', tags: ['om'] },
  { emoji: '☸️', category: 'Symbols', tags: ['wheel_of_dharma'] },
  { emoji: '✡️', category: 'Symbols', tags: ['star_of_david'] },
  { emoji: '🔯', category: 'Symbols', tags: ['six_pointed_star'] },
  { emoji: '🕎', category: 'Symbols', tags: ['menorah'] },
  { emoji: '☯️', category: 'Symbols', tags: ['yin_yang'] },
  { emoji: '☦️', category: 'Symbols', tags: ['orthodox_cross'] },
  { emoji: '🛐', category: 'Symbols', tags: ['place_of_worship'] },
  { emoji: '⛎', category: 'Symbols', tags: ['ophiuchus'] },
  { emoji: '♈️', category: 'Symbols', tags: ['aries'] },
  { emoji: '♉️', category: 'Symbols', tags: ['taurus'] },
  { emoji: '♊️', category: 'Symbols', tags: ['gemini'] },
  { emoji: '♋️', category: 'Symbols', tags: ['cancer'] },
  { emoji: '♌️', category: 'Symbols', tags: ['leo'] },
  { emoji: '♍️', category: 'Symbols', tags: ['virgo'] },
  { emoji: '♎️', category: 'Symbols', tags: ['libra'] },
  { emoji: '♏️', category: 'Symbols', tags: ['scorpius'] },
  { emoji: '♐️', category: 'Symbols', tags: ['sagittarius'] },
  { emoji: '♑️', category: 'Symbols', tags: ['capricorn'] },
  { emoji: '♒️', category: 'Symbols', tags: ['aquarius'] },
  { emoji: '♓️', category: 'Symbols', tags: ['pisces'] },
  { emoji: '🆔', category: 'Symbols', tags: ['id'] },
  { emoji: '⚛️', category: 'Symbols', tags: ['atom_symbol'] },
  { emoji: '🉑', category: 'Symbols', tags: ['accept'] },
  { emoji: '☢️', category: 'Symbols', tags: ['radioactive'] },
  { emoji: '☣️', category: 'Symbols', tags: ['biohazard'] },
  { emoji: '📴', category: 'Symbols', tags: ['mobile_phone_off'] },
  { emoji: '📳', category: 'Symbols', tags: ['vibration_mode'] },
  { emoji: '🈶', category: 'Symbols', tags: ['u6709'] },
  { emoji: '🈚️', category: 'Symbols', tags: ['u7121'] },
  { emoji: '🈸', category: 'Symbols', tags: ['u7533'] },
  { emoji: '🈺', category: 'Symbols', tags: ['u55b6'] },
  { emoji: '🈷️', category: 'Symbols', tags: ['u6708'] },
  { emoji: '✴️', category: 'Symbols', tags: ['eight_pointed_black_star'] },
  { emoji: '🆚', category: 'Symbols', tags: ['vs'] },
  { emoji: '💮', category: 'Symbols', tags: ['white_flower'] },
  { emoji: '🉐', category: 'Symbols', tags: ['ideograph_advantage'] },
  { emoji: '㊙️', category: 'Symbols', tags: ['secret'] },
  { emoji: '㊗️', category: 'Symbols', tags: ['congratulations'] },
  { emoji: '🈴', category: 'Symbols', tags: ['u5408'] },
  { emoji: '🈵', category: 'Symbols', tags: ['u6e80'] },
  { emoji: '🈹', category: 'Symbols', tags: ['u5272'] },
  { emoji: '🈲', category: 'Symbols', tags: ['u7981'] },
  { emoji: '🅰️', category: 'Symbols', tags: ['a'] },
  { emoji: '🅱️', category: 'Symbols', tags: ['b'] },
  { emoji: '🆎', category: 'Symbols', tags: ['ab'] },
  { emoji: '🆑', category: 'Symbols', tags: ['cl'] },
  { emoji: '🅾️', category: 'Symbols', tags: ['o2'] },
  { emoji: '🆘', category: 'Symbols', tags: ['sos'] },
  { emoji: '❌', category: 'Symbols', tags: ['x'] },
  { emoji: '⭕️', category: 'Symbols', tags: ['o'] },
  { emoji: '🛑', category: 'Symbols', tags: ['stop_sign'] },
  { emoji: '⛔️', category: 'Symbols', tags: ['no_entry'] },
  { emoji: '📛', category: 'Symbols', tags: ['name_badge'] },
  { emoji: '🚫', category: 'Symbols', tags: ['no_entry_sign'] },
  { emoji: '💯', category: 'Symbols', tags: ['100'] },
  { emoji: '💢', category: 'Symbols', tags: ['anger'] },
  { emoji: '♨️', category: 'Symbols', tags: ['hotsprings'] },
  { emoji: '🚷', category: 'Symbols', tags: ['no_pedestrians'] },
  { emoji: '🚯', category: 'Symbols', tags: ['do_not_litter'] },
  { emoji: '🚳', category: 'Symbols', tags: ['no_bicycles'] },
  { emoji: '🚱', category: 'Symbols', tags: ['non-potable_water'] },
  { emoji: '🔞', category: 'Symbols', tags: ['underage'] },
  { emoji: '📵', category: 'Symbols', tags: ['no_mobile_phones'] },
  { emoji: '🚭', category: 'Symbols', tags: ['no_smoking'] },
  {
    emoji: '❗️',
    category: 'Symbols',
    tags: ['exclamation', 'heavy_exclamation_mark'],
  },
  { emoji: '❕', category: 'Symbols', tags: ['grey_exclamation'] },
  { emoji: '❓', category: 'Symbols', tags: ['question'] },
  { emoji: '❔', category: 'Symbols', tags: ['grey_question'] },
  { emoji: '‼️', category: 'Symbols', tags: ['bangbang'] },
  { emoji: '⁉️', category: 'Symbols', tags: ['interrobang'] },
  { emoji: '🔅', category: 'Symbols', tags: ['low_brightness'] },
  { emoji: '🔆', category: 'Symbols', tags: ['high_brightness'] },
  { emoji: '〽️', category: 'Symbols', tags: ['part_alternation_mark'] },
  { emoji: '⚠️', category: 'Symbols', tags: ['warning'] },
  { emoji: '🚸', category: 'Symbols', tags: ['children_crossing'] },
  { emoji: '🔱', category: 'Symbols', tags: ['trident'] },
  { emoji: '⚜️', category: 'Symbols', tags: ['fleur_de_lis'] },
  { emoji: '🔰', category: 'Symbols', tags: ['beginner'] },
  { emoji: '♻️', category: 'Symbols', tags: ['recycle'] },
  { emoji: '✅', category: 'Symbols', tags: ['white_check_mark'] },
  { emoji: '🈯️', category: 'Symbols', tags: ['u6307'] },
  { emoji: '💹', category: 'Symbols', tags: ['chart'] },
  { emoji: '❇️', category: 'Symbols', tags: ['sparkle'] },
  { emoji: '✳️', category: 'Symbols', tags: ['eight_spoked_asterisk'] },
  { emoji: '❎', category: 'Symbols', tags: ['negative_squared_cross_mark'] },
  { emoji: '🌐', category: 'Symbols', tags: ['globe_with_meridians'] },
  {
    emoji: '💠',
    category: 'Symbols',
    tags: ['diamond_shape_with_a_dot_inside'],
  },
  { emoji: 'Ⓜ️', category: 'Symbols', tags: ['m'] },
  { emoji: '🌀', category: 'Symbols', tags: ['cyclone'] },
  { emoji: '💤', category: 'Symbols', tags: ['zzz'] },
  { emoji: '🏧', category: 'Symbols', tags: ['atm'] },
  { emoji: '🚾', category: 'Symbols', tags: ['wc'] },
  { emoji: '♿️', category: 'Symbols', tags: ['wheelchair'] },
  { emoji: '🅿️', category: 'Symbols', tags: ['parking'] },
  { emoji: '🈳', category: 'Symbols', tags: ['u7a7a'] },
  { emoji: '🈂️', category: 'Symbols', tags: ['sa'] },
  { emoji: '🛂', category: 'Symbols', tags: ['passport_control'] },
  { emoji: '🛃', category: 'Symbols', tags: ['customs'] },
  { emoji: '🛄', category: 'Symbols', tags: ['baggage_claim'] },
  { emoji: '🛅', category: 'Symbols', tags: ['left_luggage'] },
  { emoji: '🚹', category: 'Symbols', tags: ['mens'] },
  { emoji: '🚺', category: 'Symbols', tags: ['womens'] },
  { emoji: '🚼', category: 'Symbols', tags: ['baby_symbol'] },
  { emoji: '🚻', category: 'Symbols', tags: ['restroom'] },
  { emoji: '🚮', category: 'Symbols', tags: ['put_litter_in_its_place'] },
  { emoji: '🎦', category: 'Symbols', tags: ['cinema'] },
  { emoji: '📶', category: 'Symbols', tags: ['signal_strength'] },
  { emoji: '🈁', category: 'Symbols', tags: ['koko'] },
  { emoji: '🔣', category: 'Symbols', tags: ['symbols'] },
  { emoji: 'ℹ️', category: 'Symbols', tags: ['information_source'] },
  { emoji: '🔤', category: 'Symbols', tags: ['abc'] },
  { emoji: '🔡', category: 'Symbols', tags: ['abcd'] },
  { emoji: '🔠', category: 'Symbols', tags: ['capital_abcd'] },
  { emoji: '🆖', category: 'Symbols', tags: ['ng'] },
  { emoji: '🆗', category: 'Symbols', tags: ['ok'] },
  { emoji: '🆙', category: 'Symbols', tags: ['up'] },
  { emoji: '🆒', category: 'Symbols', tags: ['cool'] },
  { emoji: '🆕', category: 'Symbols', tags: ['new'] },
  { emoji: '🆓', category: 'Symbols', tags: ['free'] },
  { emoji: '0️⃣', category: 'Symbols', tags: ['zero'] },
  { emoji: '1️⃣', category: 'Symbols', tags: ['one'] },
  { emoji: '2️⃣', category: 'Symbols', tags: ['two'] },
  { emoji: '3️⃣', category: 'Symbols', tags: ['three'] },
  { emoji: '4️⃣', category: 'Symbols', tags: ['four'] },
  { emoji: '5️⃣', category: 'Symbols', tags: ['five'] },
  { emoji: '6️⃣', category: 'Symbols', tags: ['six'] },
  { emoji: '7️⃣', category: 'Symbols', tags: ['seven'] },
  { emoji: '8️⃣', category: 'Symbols', tags: ['eight'] },
  { emoji: '9️⃣', category: 'Symbols', tags: ['nine'] },
  { emoji: '🔟', category: 'Symbols', tags: ['keycap_ten'] },
  { emoji: '🔢', category: 'Symbols', tags: ['1234'] },
  { emoji: '#️⃣', category: 'Symbols', tags: ['hash'] },
  { emoji: '*️⃣', category: 'Symbols', tags: ['asterisk'] },
  { emoji: '▶️', category: 'Symbols', tags: ['arrow_forward'] },
  { emoji: '⏸', category: 'Symbols', tags: ['pause_button'] },
  { emoji: '⏯', category: 'Symbols', tags: ['play_or_pause_button'] },
  { emoji: '⏹', category: 'Symbols', tags: ['stop_button'] },
  { emoji: '⏺', category: 'Symbols', tags: ['record_button'] },
  { emoji: '⏭', category: 'Symbols', tags: ['next_track_button'] },
  { emoji: '⏮', category: 'Symbols', tags: ['previous_track_button'] },
  { emoji: '⏩', category: 'Symbols', tags: ['fast_forward'] },
  { emoji: '⏪', category: 'Symbols', tags: ['rewind'] },
  { emoji: '⏫', category: 'Symbols', tags: ['arrow_double_up'] },
  { emoji: '⏬', category: 'Symbols', tags: ['arrow_double_down'] },
  { emoji: '◀️', category: 'Symbols', tags: ['arrow_backward'] },
  { emoji: '🔼', category: 'Symbols', tags: ['arrow_up_small'] },
  { emoji: '🔽', category: 'Symbols', tags: ['arrow_down_small'] },
  { emoji: '➡️', category: 'Symbols', tags: ['arrow_right'] },
  { emoji: '⬅️', category: 'Symbols', tags: ['arrow_left'] },
  { emoji: '⬆️', category: 'Symbols', tags: ['arrow_up'] },
  { emoji: '⬇️', category: 'Symbols', tags: ['arrow_down'] },
  { emoji: '↗️', category: 'Symbols', tags: ['arrow_upper_right'] },
  { emoji: '↘️', category: 'Symbols', tags: ['arrow_lower_right'] },
  { emoji: '↙️', category: 'Symbols', tags: ['arrow_lower_left'] },
  { emoji: '↖️', category: 'Symbols', tags: ['arrow_upper_left'] },
  { emoji: '↕️', category: 'Symbols', tags: ['arrow_up_down'] },
  { emoji: '↔️', category: 'Symbols', tags: ['left_right_arrow'] },
  { emoji: '↪️', category: 'Symbols', tags: ['arrow_right_hook'] },
  { emoji: '↩️', category: 'Symbols', tags: ['leftwards_arrow_with_hook'] },
  { emoji: '⤴️', category: 'Symbols', tags: ['arrow_heading_up'] },
  { emoji: '⤵️', category: 'Symbols', tags: ['arrow_heading_down'] },
  { emoji: '🔀', category: 'Symbols', tags: ['twisted_rightwards_arrows'] },
  { emoji: '🔁', category: 'Symbols', tags: ['repeat'] },
  { emoji: '🔂', category: 'Symbols', tags: ['repeat_one'] },
  { emoji: '🔄', category: 'Symbols', tags: ['arrows_counterclockwise'] },
  { emoji: '🔃', category: 'Symbols', tags: ['arrows_clockwise'] },
  { emoji: '🎵', category: 'Symbols', tags: ['musical_note'] },
  { emoji: '🎶', category: 'Symbols', tags: ['notes'] },
  { emoji: '➕', category: 'Symbols', tags: ['heavy_plus_sign'] },
  { emoji: '➖', category: 'Symbols', tags: ['heavy_minus_sign'] },
  { emoji: '➗', category: 'Symbols', tags: ['heavy_division_sign'] },
  { emoji: '✖️', category: 'Symbols', tags: ['heavy_multiplication_x'] },
  { emoji: '💲', category: 'Symbols', tags: ['heavy_dollar_sign'] },
  { emoji: '💱', category: 'Symbols', tags: ['currency_exchange'] },
  { emoji: '™️', category: 'Symbols', tags: ['tm'] },
  { emoji: '©️', category: 'Symbols', tags: ['copyright'] },
  { emoji: '®️', category: 'Symbols', tags: ['registered'] },
  { emoji: '〰️', category: 'Symbols', tags: ['wavy_dash'] },
  { emoji: '➰', category: 'Symbols', tags: ['curly_loop'] },
  { emoji: '➿', category: 'Symbols', tags: ['loop'] },
  { emoji: '🔚', category: 'Symbols', tags: ['end'] },
  { emoji: '🔙', category: 'Symbols', tags: ['back'] },
  { emoji: '🔛', category: 'Symbols', tags: ['on'] },
  { emoji: '🔝', category: 'Symbols', tags: ['top'] },
  { emoji: '🔜', category: 'Symbols', tags: ['soon'] },
  { emoji: '✔️', category: 'Symbols', tags: ['heavy_check_mark'] },
  { emoji: '☑️', category: 'Symbols', tags: ['ballot_box_with_check'] },
  { emoji: '🔘', category: 'Symbols', tags: ['radio_button'] },
  { emoji: '⚪️', category: 'Symbols', tags: ['white_circle'] },
  { emoji: '⚫️', category: 'Symbols', tags: ['black_circle'] },
  { emoji: '🔴', category: 'Symbols', tags: ['red_circle'] },
  { emoji: '🔵', category: 'Symbols', tags: ['large_blue_circle'] },
  { emoji: '🔺', category: 'Symbols', tags: ['small_red_triangle'] },
  { emoji: '🔻', category: 'Symbols', tags: ['small_red_triangle_down'] },
  { emoji: '🔸', category: 'Symbols', tags: ['small_orange_diamond'] },
  { emoji: '🔹', category: 'Symbols', tags: ['small_blue_diamond'] },
  { emoji: '🔶', category: 'Symbols', tags: ['large_orange_diamond'] },
  { emoji: '🔷', category: 'Symbols', tags: ['large_blue_diamond'] },
  { emoji: '🔳', category: 'Symbols', tags: ['white_square_button'] },
  { emoji: '🔲', category: 'Symbols', tags: ['black_square_button'] },
  { emoji: '▪️', category: 'Symbols', tags: ['black_small_square'] },
  { emoji: '▫️', category: 'Symbols', tags: ['white_small_square'] },
  { emoji: '◾️', category: 'Symbols', tags: ['black_medium_small_square'] },
  { emoji: '◽️', category: 'Symbols', tags: ['white_medium_small_square'] },
  { emoji: '◼️', category: 'Symbols', tags: ['black_medium_square'] },
  { emoji: '◻️', category: 'Symbols', tags: ['white_medium_square'] },
  { emoji: '⬛️', category: 'Symbols', tags: ['black_large_square'] },
  { emoji: '⬜️', category: 'Symbols', tags: ['white_large_square'] },
  { emoji: '🔈', category: 'Symbols', tags: ['speaker'] },
  { emoji: '🔇', category: 'Symbols', tags: ['mute'] },
  { emoji: '🔉', category: 'Symbols', tags: ['sound'] },
  { emoji: '🔊', category: 'Symbols', tags: ['loud_sound'] },
  { emoji: '🔔', category: 'Symbols', tags: ['bell'] },
  { emoji: '🔕', category: 'Symbols', tags: ['no_bell'] },
  { emoji: '📣', category: 'Symbols', tags: ['mega'] },
  { emoji: '📢', category: 'Symbols', tags: ['loudspeaker'] },
  { emoji: '👁‍🗨', category: 'Symbols', tags: ['eye_speech_bubble'] },
  { emoji: '💬', category: 'Symbols', tags: ['speech_balloon'] },
  { emoji: '💭', category: 'Symbols', tags: ['thought_balloon'] },
  { emoji: '🗯', category: 'Symbols', tags: ['right_anger_bubble'] },
  { emoji: '♠️', category: 'Symbols', tags: ['spades'] },
  { emoji: '♣️', category: 'Symbols', tags: ['clubs'] },
  { emoji: '♥️', category: 'Symbols', tags: ['hearts'] },
  { emoji: '♦️', category: 'Symbols', tags: ['diamonds'] },
  { emoji: '🃏', category: 'Symbols', tags: ['black_joker'] },
  { emoji: '🎴', category: 'Symbols', tags: ['flower_playing_cards'] },
  { emoji: '🀄️', category: 'Symbols', tags: ['mahjong'] },
  { emoji: '🕐', category: 'Symbols', tags: ['clock1'] },
  { emoji: '🕑', category: 'Symbols', tags: ['clock2'] },
  { emoji: '🕒', category: 'Symbols', tags: ['clock3'] },
  { emoji: '🕓', category: 'Symbols', tags: ['clock4'] },
  { emoji: '🕔', category: 'Symbols', tags: ['clock5'] },
  { emoji: '🕕', category: 'Symbols', tags: ['clock6'] },
  { emoji: '🕖', category: 'Symbols', tags: ['clock7'] },
  { emoji: '🕗', category: 'Symbols', tags: ['clock8'] },
  { emoji: '🕘', category: 'Symbols', tags: ['clock9'] },
  { emoji: '🕙', category: 'Symbols', tags: ['clock10'] },
  { emoji: '🕚', category: 'Symbols', tags: ['clock11'] },
  { emoji: '🕛', category: 'Symbols', tags: ['clock12'] },
  { emoji: '🕜', category: 'Symbols', tags: ['clock130'] },
  { emoji: '🕝', category: 'Symbols', tags: ['clock230'] },
  { emoji: '🕞', category: 'Symbols', tags: ['clock330'] },
  { emoji: '🕟', category: 'Symbols', tags: ['clock430'] },
  { emoji: '🕠', category: 'Symbols', tags: ['clock530'] },
  { emoji: '🕡', category: 'Symbols', tags: ['clock630'] },
  { emoji: '🕢', category: 'Symbols', tags: ['clock730'] },
  { emoji: '🕣', category: 'Symbols', tags: ['clock830'] },
  { emoji: '🕤', category: 'Symbols', tags: ['clock930'] },
  { emoji: '🕥', category: 'Symbols', tags: ['clock1030'] },
  { emoji: '🕦', category: 'Symbols', tags: ['clock1130'] },
  { emoji: '🕧', category: 'Symbols', tags: ['clock1230'] },
  { emoji: '🏳️', category: 'Flags', tags: ['white_flag'] },
  { emoji: '🏴', category: 'Flags', tags: ['black_flag'] },
  { emoji: '🏁', category: 'Flags', tags: ['checkered_flag'] },
  { emoji: '🚩', category: 'Flags', tags: ['triangular_flag_on_post'] },
  { emoji: '🏳️‍🌈', category: 'Flags', tags: ['rainbow_flag'] },
  { emoji: '🇦🇫', category: 'Flags', tags: ['afghanistan'] },
  { emoji: '🇦🇽', category: 'Flags', tags: ['aland_islands'] },
  { emoji: '🇦🇱', category: 'Flags', tags: ['albania'] },
  { emoji: '🇩🇿', category: 'Flags', tags: ['algeria'] },
  { emoji: '🇦🇸', category: 'Flags', tags: ['american_samoa'] },
  { emoji: '🇦🇩', category: 'Flags', tags: ['andorra'] },
  { emoji: '🇦🇴', category: 'Flags', tags: ['angola'] },
  { emoji: '🇦🇮', category: 'Flags', tags: ['anguilla'] },
  { emoji: '🇦🇶', category: 'Flags', tags: ['antarctica'] },
  { emoji: '🇦🇬', category: 'Flags', tags: ['antigua_barbuda'] },
  { emoji: '🇦🇷', category: 'Flags', tags: ['argentina'] },
  { emoji: '🇦🇲', category: 'Flags', tags: ['armenia'] },
  { emoji: '🇦🇼', category: 'Flags', tags: ['aruba'] },
  { emoji: '🇦🇺', category: 'Flags', tags: ['australia'] },
  { emoji: '🇦🇹', category: 'Flags', tags: ['austria'] },
  { emoji: '🇦🇿', category: 'Flags', tags: ['azerbaijan'] },
  { emoji: '🇧🇸', category: 'Flags', tags: ['bahamas'] },
  { emoji: '🇧🇭', category: 'Flags', tags: ['bahrain'] },
  { emoji: '🇧🇩', category: 'Flags', tags: ['bangladesh'] },
  { emoji: '🇧🇧', category: 'Flags', tags: ['barbados'] },
  { emoji: '🇧🇾', category: 'Flags', tags: ['belarus'] },
  { emoji: '🇧🇪', category: 'Flags', tags: ['belgium'] },
  { emoji: '🇧🇿', category: 'Flags', tags: ['belize'] },
  { emoji: '🇧🇯', category: 'Flags', tags: ['benin'] },
  { emoji: '🇧🇲', category: 'Flags', tags: ['bermuda'] },
  { emoji: '🇧🇹', category: 'Flags', tags: ['bhutan'] },
  { emoji: '🇧🇴', category: 'Flags', tags: ['bolivia'] },
  { emoji: '🇧🇶', category: 'Flags', tags: ['caribbean_netherlands'] },
  { emoji: '🇧🇦', category: 'Flags', tags: ['bosnia_herzegovina'] },
  { emoji: '🇧🇼', category: 'Flags', tags: ['botswana'] },
  { emoji: '🇧🇷', category: 'Flags', tags: ['brazil'] },
  { emoji: '🇮🇴', category: 'Flags', tags: ['british_indian_ocean_territory'] },
  { emoji: '🇻🇬', category: 'Flags', tags: ['british_virgin_islands'] },
  { emoji: '🇧🇳', category: 'Flags', tags: ['brunei'] },
  { emoji: '🇧🇬', category: 'Flags', tags: ['bulgaria'] },
  { emoji: '🇧🇫', category: 'Flags', tags: ['burkina_faso'] },
  { emoji: '🇧🇮', category: 'Flags', tags: ['burundi'] },
  { emoji: '🇨🇻', category: 'Flags', tags: ['cape_verde'] },
  { emoji: '🇰🇭', category: 'Flags', tags: ['cambodia'] },
  { emoji: '🇨🇲', category: 'Flags', tags: ['cameroon'] },
  { emoji: '🇨🇦', category: 'Flags', tags: ['canada'] },
  { emoji: '🇮🇨', category: 'Flags', tags: ['canary_islands'] },
  { emoji: '🇰🇾', category: 'Flags', tags: ['cayman_islands'] },
  { emoji: '🇨🇫', category: 'Flags', tags: ['central_african_republic'] },
  { emoji: '🇹🇩', category: 'Flags', tags: ['chad'] },
  { emoji: '🇨🇱', category: 'Flags', tags: ['chile'] },
  { emoji: '🇨🇳', category: 'Flags', tags: ['cn'] },
  { emoji: '🇨🇽', category: 'Flags', tags: ['christmas_island'] },
  { emoji: '🇨🇨', category: 'Flags', tags: ['cocos_islands'] },
  { emoji: '🇨🇴', category: 'Flags', tags: ['colombia'] },
  { emoji: '🇰🇲', category: 'Flags', tags: ['comoros'] },
  { emoji: '🇨🇬', category: 'Flags', tags: ['congo_brazzaville'] },
  { emoji: '🇨🇩', category: 'Flags', tags: ['congo_kinshasa'] },
  { emoji: '🇨🇰', category: 'Flags', tags: ['cook_islands'] },
  { emoji: '🇨🇷', category: 'Flags', tags: ['costa_rica'] },
  { emoji: '🇨🇮', category: 'Flags', tags: ['cote_divoire'] },
  { emoji: '🇭🇷', category: 'Flags', tags: ['croatia'] },
  { emoji: '🇨🇺', category: 'Flags', tags: ['cuba'] },
  { emoji: '🇨🇼', category: 'Flags', tags: ['curacao'] },
  { emoji: '🇨🇾', category: 'Flags', tags: ['cyprus'] },
  { emoji: '🇨🇿', category: 'Flags', tags: ['czech_republic'] },
  { emoji: '🇩🇰', category: 'Flags', tags: ['denmark'] },
  { emoji: '🇩🇯', category: 'Flags', tags: ['djibouti'] },
  { emoji: '🇩🇲', category: 'Flags', tags: ['dominica'] },
  { emoji: '🇩🇴', category: 'Flags', tags: ['dominican_republic'] },
  { emoji: '🇪🇨', category: 'Flags', tags: ['ecuador'] },
  { emoji: '🇪🇬', category: 'Flags', tags: ['egypt'] },
  { emoji: '🇸🇻', category: 'Flags', tags: ['el_salvador'] },
  { emoji: '🇬🇶', category: 'Flags', tags: ['equatorial_guinea'] },
  { emoji: '🇪🇷', category: 'Flags', tags: ['eritrea'] },
  { emoji: '🇪🇪', category: 'Flags', tags: ['estonia'] },
  { emoji: '🇪🇹', category: 'Flags', tags: ['ethiopia'] },
  { emoji: '🇪🇺', category: 'Flags', tags: ['eu', 'european_union'] },
  { emoji: '🇫🇰', category: 'Flags', tags: ['falkland_islands'] },
  { emoji: '🇫🇴', category: 'Flags', tags: ['faroe_islands'] },
  { emoji: '🇫🇯', category: 'Flags', tags: ['fiji'] },
  { emoji: '🇫🇮', category: 'Flags', tags: ['finland'] },
  { emoji: '🇫🇷', category: 'Flags', tags: ['fr'] },
  { emoji: '🇬🇫', category: 'Flags', tags: ['french_guiana'] },
  { emoji: '🇵🇫', category: 'Flags', tags: ['french_polynesia'] },
  { emoji: '🇹🇫', category: 'Flags', tags: ['french_southern_territories'] },
  { emoji: '🇬🇦', category: 'Flags', tags: ['gabon'] },
  { emoji: '🇬🇲', category: 'Flags', tags: ['gambia'] },
  { emoji: '🇬🇪', category: 'Flags', tags: ['georgia'] },
  { emoji: '🇩🇪', category: 'Flags', tags: ['de'] },
  { emoji: '🇬🇭', category: 'Flags', tags: ['ghana'] },
  { emoji: '🇬🇮', category: 'Flags', tags: ['gibraltar'] },
  { emoji: '🇬🇷', category: 'Flags', tags: ['greece'] },
  { emoji: '🇬🇱', category: 'Flags', tags: ['greenland'] },
  { emoji: '🇬🇩', category: 'Flags', tags: ['grenada'] },
  { emoji: '🇬🇵', category: 'Flags', tags: ['guadeloupe'] },
  { emoji: '🇬🇺', category: 'Flags', tags: ['guam'] },
  { emoji: '🇬🇹', category: 'Flags', tags: ['guatemala'] },
  { emoji: '🇬🇬', category: 'Flags', tags: ['guernsey'] },
  { emoji: '🇬🇳', category: 'Flags', tags: ['guinea'] },
  { emoji: '🇬🇼', category: 'Flags', tags: ['guinea_bissau'] },
  { emoji: '🇬🇾', category: 'Flags', tags: ['guyana'] },
  { emoji: '🇭🇹', category: 'Flags', tags: ['haiti'] },
  { emoji: '🇭🇳', category: 'Flags', tags: ['honduras'] },
  { emoji: '🇭🇰', category: 'Flags', tags: ['hong_kong'] },
  { emoji: '🇭🇺', category: 'Flags', tags: ['hungary'] },
  { emoji: '🇮🇸', category: 'Flags', tags: ['iceland'] },
  { emoji: '🇮🇳', category: 'Flags', tags: ['india'] },
  { emoji: '🇮🇩', category: 'Flags', tags: ['indonesia'] },
  { emoji: '🇮🇷', category: 'Flags', tags: ['iran'] },
  { emoji: '🇮🇶', category: 'Flags', tags: ['iraq'] },
  { emoji: '🇮🇪', category: 'Flags', tags: ['ireland'] },
  { emoji: '🇮🇲', category: 'Flags', tags: ['isle_of_man'] },
  { emoji: '🇮🇱', category: 'Flags', tags: ['israel'] },
  { emoji: '🇮🇹', category: 'Flags', tags: ['it'] },
  { emoji: '🇯🇲', category: 'Flags', tags: ['jamaica'] },
  { emoji: '🇯🇵', category: 'Flags', tags: ['jp'] },
  { emoji: '🎌', category: 'Flags', tags: ['crossed_flags'] },
  { emoji: '🇯🇪', category: 'Flags', tags: ['jersey'] },
  { emoji: '🇯🇴', category: 'Flags', tags: ['jordan'] },
  { emoji: '🇰🇿', category: 'Flags', tags: ['kazakhstan'] },
  { emoji: '🇰🇪', category: 'Flags', tags: ['kenya'] },
  { emoji: '🇰🇮', category: 'Flags', tags: ['kiribati'] },
  { emoji: '🇽🇰', category: 'Flags', tags: ['kosovo'] },
  { emoji: '🇰🇼', category: 'Flags', tags: ['kuwait'] },
  { emoji: '🇰🇬', category: 'Flags', tags: ['kyrgyzstan'] },
  { emoji: '🇱🇦', category: 'Flags', tags: ['laos'] },
  { emoji: '🇱🇻', category: 'Flags', tags: ['latvia'] },
  { emoji: '🇱🇧', category: 'Flags', tags: ['lebanon'] },
  { emoji: '🇱🇸', category: 'Flags', tags: ['lesotho'] },
  { emoji: '🇱🇷', category: 'Flags', tags: ['liberia'] },
  { emoji: '🇱🇾', category: 'Flags', tags: ['libya'] },
  { emoji: '🇱🇮', category: 'Flags', tags: ['liechtenstein'] },
  { emoji: '🇱🇹', category: 'Flags', tags: ['lithuania'] },
  { emoji: '🇱🇺', category: 'Flags', tags: ['luxembourg'] },
  { emoji: '🇲🇴', category: 'Flags', tags: ['macau'] },
  { emoji: '🇲🇰', category: 'Flags', tags: ['macedonia'] },
  { emoji: '🇲🇬', category: 'Flags', tags: ['madagascar'] },
  { emoji: '🇲🇼', category: 'Flags', tags: ['malawi'] },
  { emoji: '🇲🇾', category: 'Flags', tags: ['malaysia'] },
  { emoji: '🇲🇻', category: 'Flags', tags: ['maldives'] },
  { emoji: '🇲🇱', category: 'Flags', tags: ['mali'] },
  { emoji: '🇲🇹', category: 'Flags', tags: ['malta'] },
  { emoji: '🇲🇭', category: 'Flags', tags: ['marshall_islands'] },
  { emoji: '🇲🇶', category: 'Flags', tags: ['martinique'] },
  { emoji: '🇲🇷', category: 'Flags', tags: ['mauritania'] },
  { emoji: '🇲🇺', category: 'Flags', tags: ['mauritius'] },
  { emoji: '🇾🇹', category: 'Flags', tags: ['mayotte'] },
  { emoji: '🇲🇽', category: 'Flags', tags: ['mexico'] },
  { emoji: '🇫🇲', category: 'Flags', tags: ['micronesia'] },
  { emoji: '🇲🇩', category: 'Flags', tags: ['moldova'] },
  { emoji: '🇲🇨', category: 'Flags', tags: ['monaco'] },
  { emoji: '🇲🇳', category: 'Flags', tags: ['mongolia'] },
  { emoji: '🇲🇪', category: 'Flags', tags: ['montenegro'] },
  { emoji: '🇲🇸', category: 'Flags', tags: ['montserrat'] },
  { emoji: '🇲🇦', category: 'Flags', tags: ['morocco'] },
  { emoji: '🇲🇿', category: 'Flags', tags: ['mozambique'] },
  { emoji: '🇲🇲', category: 'Flags', tags: ['myanmar'] },
  { emoji: '🇳🇦', category: 'Flags', tags: ['namibia'] },
  { emoji: '🇳🇷', category: 'Flags', tags: ['nauru'] },
  { emoji: '🇳🇵', category: 'Flags', tags: ['nepal'] },
  { emoji: '🇳🇱', category: 'Flags', tags: ['netherlands'] },
  { emoji: '🇳🇨', category: 'Flags', tags: ['new_caledonia'] },
  { emoji: '🇳🇿', category: 'Flags', tags: ['new_zealand'] },
  { emoji: '🇳🇮', category: 'Flags', tags: ['nicaragua'] },
  { emoji: '🇳🇪', category: 'Flags', tags: ['niger'] },
  { emoji: '🇳🇬', category: 'Flags', tags: ['nigeria'] },
  { emoji: '🇳🇺', category: 'Flags', tags: ['niue'] },
  { emoji: '🇳🇫', category: 'Flags', tags: ['norfolk_island'] },
  { emoji: '🇲🇵', category: 'Flags', tags: ['northern_mariana_islands'] },
  { emoji: '🇰🇵', category: 'Flags', tags: ['north_korea'] },
  { emoji: '🇳🇴', category: 'Flags', tags: ['norway'] },
  { emoji: '🇴🇲', category: 'Flags', tags: ['oman'] },
  { emoji: '🇵🇰', category: 'Flags', tags: ['pakistan'] },
  { emoji: '🇵🇼', category: 'Flags', tags: ['palau'] },
  { emoji: '🇵🇸', category: 'Flags', tags: ['palestinian_territories'] },
  { emoji: '🇵🇦', category: 'Flags', tags: ['panama'] },
  { emoji: '🇵🇬', category: 'Flags', tags: ['papua_new_guinea'] },
  { emoji: '🇵🇾', category: 'Flags', tags: ['paraguay'] },
  { emoji: '🇵🇪', category: 'Flags', tags: ['peru'] },
  { emoji: '🇵🇭', category: 'Flags', tags: ['philippines'] },
  { emoji: '🇵🇳', category: 'Flags', tags: ['pitcairn_islands'] },
  { emoji: '🇵🇱', category: 'Flags', tags: ['poland'] },
  { emoji: '🇵🇹', category: 'Flags', tags: ['portugal'] },
  { emoji: '🇵🇷', category: 'Flags', tags: ['puerto_rico'] },
  { emoji: '🇶🇦', category: 'Flags', tags: ['qatar'] },
  { emoji: '🇷🇪', category: 'Flags', tags: ['reunion'] },
  { emoji: '🇷🇴', category: 'Flags', tags: ['romania'] },
  { emoji: '🇷🇺', category: 'Flags', tags: ['ru'] },
  { emoji: '🇷🇼', category: 'Flags', tags: ['rwanda'] },
  { emoji: '🇧🇱', category: 'Flags', tags: ['st_barthelemy'] },
  { emoji: '🇸🇭', category: 'Flags', tags: ['st_helena'] },
  { emoji: '🇰🇳', category: 'Flags', tags: ['st_kitts_nevis'] },
  { emoji: '🇱🇨', category: 'Flags', tags: ['st_lucia'] },
  { emoji: '🇵🇲', category: 'Flags', tags: ['st_pierre_miquelon'] },
  { emoji: '🇻🇨', category: 'Flags', tags: ['st_vincent_grenadines'] },
  { emoji: '🇼🇸', category: 'Flags', tags: ['samoa'] },
  { emoji: '🇸🇲', category: 'Flags', tags: ['san_marino'] },
  { emoji: '🇸🇹', category: 'Flags', tags: ['sao_tome_principe'] },
  { emoji: '🇸🇦', category: 'Flags', tags: ['saudi_arabia'] },
  { emoji: '🇸🇳', category: 'Flags', tags: ['senegal'] },
  { emoji: '🇷🇸', category: 'Flags', tags: ['serbia'] },
  { emoji: '🇸🇨', category: 'Flags', tags: ['seychelles'] },
  { emoji: '🇸🇱', category: 'Flags', tags: ['sierra_leone'] },
  { emoji: '🇸🇬', category: 'Flags', tags: ['singapore'] },
  { emoji: '🇸🇽', category: 'Flags', tags: ['sint_maarten'] },
  { emoji: '🇸🇰', category: 'Flags', tags: ['slovakia'] },
  { emoji: '🇸🇮', category: 'Flags', tags: ['slovenia'] },
  { emoji: '🇸🇧', category: 'Flags', tags: ['solomon_islands'] },
  { emoji: '🇸🇴', category: 'Flags', tags: ['somalia'] },
  { emoji: '🇿🇦', category: 'Flags', tags: ['south_africa'] },
  {
    emoji: '🇬🇸',
    category: 'Flags',
    tags: ['south_georgia_south_sandwich_islands'],
  },
  { emoji: '🇰🇷', category: 'Flags', tags: ['kr'] },
  { emoji: '🇸🇸', category: 'Flags', tags: ['south_sudan'] },
  { emoji: '🇪🇸', category: 'Flags', tags: ['es'] },
  { emoji: '🇱🇰', category: 'Flags', tags: ['sri_lanka'] },
  { emoji: '🇸🇩', category: 'Flags', tags: ['sudan'] },
  { emoji: '🇸🇷', category: 'Flags', tags: ['suriname'] },
  { emoji: '🇸🇿', category: 'Flags', tags: ['swaziland'] },
  { emoji: '🇸🇪', category: 'Flags', tags: ['sweden'] },
  { emoji: '🇨🇭', category: 'Flags', tags: ['switzerland'] },
  { emoji: '🇸🇾', category: 'Flags', tags: ['syria'] },
  { emoji: '🇹🇼', category: 'Flags', tags: ['taiwan'] },
  { emoji: '🇹🇯', category: 'Flags', tags: ['tajikistan'] },
  { emoji: '🇹🇿', category: 'Flags', tags: ['tanzania'] },
  { emoji: '🇹🇭', category: 'Flags', tags: ['thailand'] },
  { emoji: '🇹🇱', category: 'Flags', tags: ['timor_leste'] },
  { emoji: '🇹🇬', category: 'Flags', tags: ['togo'] },
  { emoji: '🇹🇰', category: 'Flags', tags: ['tokelau'] },
  { emoji: '🇹🇴', category: 'Flags', tags: ['tonga'] },
  { emoji: '🇹🇹', category: 'Flags', tags: ['trinidad_tobago'] },
  { emoji: '🇹🇳', category: 'Flags', tags: ['tunisia'] },
  { emoji: '🇹🇷', category: 'Flags', tags: ['tr'] },
  { emoji: '🇹🇲', category: 'Flags', tags: ['turkmenistan'] },
  { emoji: '🇹🇨', category: 'Flags', tags: ['turks_caicos_islands'] },
  { emoji: '🇹🇻', category: 'Flags', tags: ['tuvalu'] },
  { emoji: '🇺🇬', category: 'Flags', tags: ['uganda'] },
  { emoji: '🇺🇦', category: 'Flags', tags: ['ukraine'] },
  { emoji: '🇦🇪', category: 'Flags', tags: ['united_arab_emirates'] },
  { emoji: '🇬🇧', category: 'Flags', tags: ['gb', 'uk'] },
  { emoji: '🇺🇸', category: 'Flags', tags: ['us'] },
  { emoji: '🇻🇮', category: 'Flags', tags: ['us_virgin_islands'] },
  { emoji: '🇺🇾', category: 'Flags', tags: ['uruguay'] },
  { emoji: '🇺🇿', category: 'Flags', tags: ['uzbekistan'] },
  { emoji: '🇻🇺', category: 'Flags', tags: ['vanuatu'] },
  { emoji: '🇻🇦', category: 'Flags', tags: ['vatican_city'] },
  { emoji: '🇻🇪', category: 'Flags', tags: ['venezuela'] },
  { emoji: '🇻🇳', category: 'Flags', tags: ['vietnam'] },
  { emoji: '🇼🇫', category: 'Flags', tags: ['wallis_futuna'] },
  { emoji: '🇪🇭', category: 'Flags', tags: ['western_sahara'] },
  { emoji: '🇾🇪', category: 'Flags', tags: ['yemen'] },
  { emoji: '🇿🇲', category: 'Flags', tags: ['zambia'] },
  { emoji: '🇿🇼', category: 'Flags', tags: ['zimbabwe'] },
];

export default emojisDefault;
